var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwedbankLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 277 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffb560;}.cls-2{fill:url(#Namnl\xF6s_\xF6vertoning_4);}.cls-3{fill:url(#Ny_\xF6vertoningsruta_3-22);}.cls-4{fill:#eeaf67;}.cls-5{fill:url(#Ny_\xF6vertoningsruta_3-14);}.cls-6{fill:#f8a943;}.cls-7{fill:url(#Ny_\xF6vertoningsruta_3-9);}.cls-8{fill:url(#Ny_\xF6vertoningsruta_3-38);}.cls-9{fill:url(#Ny_\xF6vertoningsruta_3-39);}.cls-10{fill:#96441e;}.cls-11{fill:#bc6327;}.cls-12{fill:#ffc278;}.cls-13{fill:#d47429;}.cls-14{fill:url(#Ny_\xF6vertoningsruta_3-20);}.cls-15{fill:#8d4428;}.cls-16{fill:#b46027;}.cls-17{fill:#e7944b;}.cls-18{fill:#a5572a;}.cls-19{fill:#7e3717;}.cls-20{fill:#9a4921;}.cls-21{fill:#ea913e;}.cls-22{fill:url(#Ny_\xF6vertoningsruta_3-3);}.cls-23{fill:url(#Ny_\xF6vertoningsruta_3-17);}.cls-24{fill:#c57231;}.cls-25{fill:#7a2c13;}.cls-26{fill:#e69646;}.cls-27{fill:url(#Ny_\xF6vertoningsruta_3-34);}.cls-28{fill:#e48e33;}.cls-29{fill:#6c2b13;}.cls-30{fill:#d27c3c;}.cls-31{fill:#823d1e;}.cls-32{fill:#bf6b29;}.cls-33{fill:url(#Ny_\xF6vertoningsruta_3-7);}.cls-34{fill:#aa5e33;}.cls-35{fill:#fdac4a;}.cls-36{fill:#a35622;}.cls-37{fill:#faaf5a;}.cls-38{fill:url(#Ny_\xF6vertoningsruta_3-21);}.cls-39{fill:#fcb664;}.cls-40{fill:#efa952;}.cls-41{fill:url(#Namnl\xF6s_\xF6vertoning_9);}.cls-41,.cls-42{fill-rule:evenodd;}.cls-43{fill:url(#Ny_\xF6vertoningsruta_3-26);}.cls-44{fill:#994b17;}.cls-45{fill:#56220c;}.cls-46{fill:#642813;}.cls-47{fill:url(#Ny_\xF6vertoningsruta_3-11);}.cls-48{fill:#f29b40;}.cls-49{fill:#ffc283;}.cls-50{fill:url(#Ny_\xF6vertoningsruta_3-32);}.cls-51{fill:#ad5725;}.cls-52{fill:#dc8730;}.cls-53{fill:url(#Ny_\xF6vertoningsruta_3-12);}.cls-54{fill:#ffce89;}.cls-55{fill:#d89050;}.cls-56{fill:#944428;}.cls-57{fill:#94441e;}.cls-58{fill:#994822;}.cls-59{fill:url(#Ny_\xF6vertoningsruta_3-29);}.cls-60{fill:#b96534;}.cls-61{fill:url(#Ny_\xF6vertoningsruta_3-15);}.cls-62{fill:url(#Ny_\xF6vertoningsruta_3-2);}.cls-63{fill:#ffcb80;}.cls-64{fill:url(#Ny_\xF6vertoningsruta_3-23);}.cls-65{fill:url(#Ny_\xF6vertoningsruta_3-36);}.cls-66{fill:#9f5024;}.cls-67{fill:url(#Ny_\xF6vertoningsruta_3-10);}.cls-68{fill:url(#Ny_\xF6vertoningsruta_3-37);}.cls-69{fill:#b43c19;}.cls-70{fill:#ff5f00;}.cls-71{fill:#ffd79d;}.cls-72{fill:url(#Ny_\xF6vertoningsruta_3-4);}.cls-73{fill:url(#Ny_\xF6vertoningsruta_3-25);}.cls-74{fill:#ba6019;}.cls-75{fill:url(#Ny_\xF6vertoningsruta_3-8);}.cls-76{fill:none;}.cls-77{fill:#ec9c4b;}.cls-78{fill:url(#Ny_\xF6vertoningsruta_3-28);}.cls-79{fill:#c27138;}.cls-80{fill:url(#Ny_\xF6vertoningsruta_3-6);}.cls-81{fill:url(#Ny_\xF6vertoningsruta_3-18);}.cls-42{fill:url(#Ny_\xF6vertoningsruta_3);}.cls-82{fill:#76310a;}.cls-83{fill:url(#Ny_\xF6vertoningsruta_3-16);}.cls-84{fill:url(#Ny_\xF6vertoningsruta_3-5);}.cls-85{fill:url(#Ny_\xF6vertoningsruta_3-31);}.cls-86{fill:#ffc378;}.cls-87{fill:#af6638;}.cls-88{fill:#eb962a;}.cls-89{fill:#ffd68e;}.cls-90{fill:#db7b29;}.cls-91{fill:url(#Ny_\xF6vertoningsruta_3-33);}.cls-92{fill:#964c25;}.cls-93{fill:#e5872b;}.cls-94{fill:#d57c3f;}.cls-95{fill:#ffcd85;}.cls-96{fill:url(#Ny_\xF6vertoningsruta_3-19);}.cls-97{fill:url(#Ny_\xF6vertoningsruta_3-24);}.cls-98{fill:#f49e4d;}.cls-99{fill:url(#Ny_\xF6vertoningsruta_3-35);}.cls-100{fill:url(#Ny_\xF6vertoningsruta_3-27);}.cls-101{fill:url(#Ny_\xF6vertoningsruta_3-30);}.cls-102{fill:url(#Namnl\xF6s_\xF6vertoning_3);}.cls-103{fill:#a04e14;}.cls-104{fill:#aa5a28;}.cls-105{fill:url(#Ny_\xF6vertoningsruta_3-13);}.cls-106{fill:#dd8732;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3",
    cx: 254.86,
    cy: 13.26,
    fx: 254.86,
    fy: 13.26,
    r: 42.06,
    gradientTransform: "translate(-3.1 3.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ffcf5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ffbe46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ff9b0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f7770f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f3640f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e65f19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_4",
    x1: 261.95,
    y1: 5.86,
    x2: 228.81,
    y2: 54.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffe6a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fbc577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f5871e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f4861d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e1690f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#cc5b0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9b3d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7e2a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73230a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_3",
    x1: 230.05,
    y1: 53.05,
    x2: 260.5,
    y2: 7.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe6a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fbc877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f5871e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f4861d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e1690f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#da640e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ae480c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8d340b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7a270a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#73230a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_9",
    cx: 251.43,
    cy: 10.89,
    fx: 251.43,
    fy: 10.89,
    r: 47.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc85a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f59619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e56a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#dc5014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ba3f18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b43c19"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-2",
    cx: 248.56,
    cy: 11.59,
    fx: 248.56,
    fy: 11.59,
    r: 45.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-3",
    cx: 248.48,
    cy: 11.55,
    fx: 248.48,
    fy: 11.55,
    r: 45.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-4",
    cx: 248.45,
    cy: 11.5,
    fx: 248.45,
    fy: 11.5,
    r: 45.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-5",
    cx: 248.6,
    cy: 11.52,
    fx: 248.6,
    fy: 11.52,
    r: 45.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-6",
    cx: 246.82,
    cy: 9.46,
    fx: 246.82,
    fy: 9.46,
    r: 50.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-7",
    cx: 249.48,
    cy: 11,
    fx: 249.48,
    fy: 11,
    r: 46.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-8",
    cx: 247.73,
    cy: 9.98,
    fx: 247.73,
    fy: 9.98,
    r: 48.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-9",
    cx: 248.18,
    cy: 11.65,
    fx: 248.18,
    fy: 11.65,
    r: 45.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-10",
    cx: 247.67,
    cy: 10.89,
    fx: 247.67,
    fy: 10.89,
    r: 47.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-11",
    cx: 249.21,
    cy: 11.26,
    fx: 249.21,
    fy: 11.26,
    r: 46.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-12",
    cx: 247.79,
    cy: 11.58,
    fx: 247.79,
    fy: 11.58,
    r: 47.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-13",
    cx: 248.28,
    cy: 11.32,
    fx: 248.28,
    fy: 11.32,
    r: 46.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-14",
    cx: 248.39,
    cy: 11.39,
    fx: 248.39,
    fy: 11.39,
    r: 47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-15",
    cx: 248.31,
    cy: 11.69,
    fx: 248.31,
    fy: 11.69,
    r: 46.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-16",
    cx: 248.53,
    cy: 11.75,
    fx: 248.53,
    fy: 11.75,
    r: 47.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-17",
    cx: 248.3,
    cy: 11.82,
    fx: 248.3,
    fy: 11.82,
    r: 46.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-18",
    cx: 248.49,
    cy: 11.68,
    fx: 248.49,
    fy: 11.68,
    r: 46.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-19",
    cx: 248.55,
    cy: 11.94,
    fx: 248.55,
    fy: 11.94,
    r: 47.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-20",
    cx: 248.66,
    cy: 11.92,
    fx: 248.66,
    fy: 11.92,
    r: 46.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-21",
    cx: 248.79,
    cy: 11.45,
    fx: 248.79,
    fy: 11.45,
    r: 46.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-22",
    cx: 248.28,
    cy: 11.53,
    fx: 248.28,
    fy: 11.53,
    r: 46.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-23",
    cx: 248.77,
    cy: 11.71,
    fx: 248.77,
    fy: 11.71,
    r: 46.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-24",
    cx: 249.07,
    cy: 11.09,
    fx: 249.07,
    fy: 11.09,
    r: 47.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-25",
    cx: 248.81,
    cy: 11.84,
    fx: 248.81,
    fy: 11.84,
    r: 46.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-26",
    cx: 249.42,
    cy: 11.25,
    fx: 249.42,
    fy: 11.25,
    r: 47.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-27",
    cx: 248.87,
    cy: 11.31,
    fx: 248.87,
    fy: 11.31,
    r: 46.29,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-28",
    cx: 249.61,
    cy: 11.42,
    fx: 249.61,
    fy: 11.42,
    r: 47.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-29",
    cx: 248.8,
    cy: 11.42,
    fx: 248.8,
    fy: 11.42,
    r: 46.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-30",
    cx: 249.29,
    cy: 10.45,
    fx: 249.29,
    fy: 10.45,
    r: 47.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-31",
    cx: 249.21,
    cy: 11.04,
    fx: 249.21,
    fy: 11.04,
    r: 46.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-32",
    cx: 249.15,
    cy: 11.04,
    fx: 249.15,
    fy: 11.04,
    r: 46.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-33",
    cx: 249.12,
    cy: 10.67,
    fx: 249.12,
    fy: 10.67,
    r: 47.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-34",
    cx: 248.26,
    cy: 10.17,
    fx: 248.26,
    fy: 10.17,
    r: 48.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-35",
    cx: 249.22,
    cy: 10.35,
    fx: 249.22,
    fy: 10.35,
    r: 47.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-36",
    cx: 248.11,
    cy: 10.13,
    fx: 248.11,
    fy: 10.13,
    r: 48.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-37",
    cx: 248.19,
    cy: 10.75,
    fx: 248.19,
    fy: 10.75,
    r: 47.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-38",
    cx: 248.02,
    cy: 10.68,
    fx: 248.02,
    fy: 10.68,
    r: 46.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ny_\\xF6vertoningsruta_3-39",
    cx: 246.87,
    cy: 9.08,
    fx: 246.87,
    fy: 9.08,
    r: 49.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Ny_\\xF6vertoningsruta_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m272.42,30.35c0,14.96-12.13,27.09-27.09,27.09s-27.09-12.13-27.09-27.09,12.13-27.09,27.09-27.09,27.09,12.13,27.09,27.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m245.34.97c-16.23,0-29.39,13.16-29.39,29.39s13.16,29.39,29.39,29.39,29.39-13.16,29.39-29.39S261.57.97,245.34.97Zm0,57.49c-15.52,0-28.11-12.58-28.11-28.11s12.58-28.11,28.11-28.11,28.11,12.58,28.11,28.11-12.58,28.11-28.11,28.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m245.34,2.25c-15.52,0-28.11,12.58-28.11,28.11s12.58,28.11,28.11,28.11,28.11-12.58,28.11-28.11-12.58-28.11-28.11-28.11Zm0,54.94c-14.82,0-26.83-12.01-26.83-26.83s12.01-26.83,26.83-26.83,26.83,12.01,26.83,26.83-12.01,26.83-26.83,26.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m245.34,58.59c-15.57,0-28.24-12.67-28.24-28.24s12.67-28.24,28.24-28.24,28.24,12.67,28.24,28.24-12.67,28.24-28.24,28.24Zm0-56.22c-15.43,0-27.98,12.55-27.98,27.98s12.55,27.98,27.98,27.98,27.98-12.55,27.98-27.98-12.55-27.98-27.98-27.98Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m268.83,34.06c-.19.89-2.54.73-3.24.72-.84-.02-1.08.87-1.08.87,0,0-1.38.2-2.08.18-2.12-.04-2.68-.83-2.68-.83-.96-.02-1.04.85-1.95,1.14-.51.16-1.16-.88-1.16-.88-1.28.12-3.89,0-4.34-.31-.6-.42-1.82-2.57-2.27-2.59-.22,0-.43-.03-.71,0-.64.07-.97.69-.89,1.69.08,1.01.33,2.98.47,3.66.27,1.28,2.72,1.81,3.77,2.36l.09.52c-1.21-.16-4.08-.49-3.51.19.21.25.61.64.9,1.02v.44c-.74-.31-2.67-1.19-4.81-1.21-1.86-.02-3.28.45-4.8,1.19l-.05-.48c.44-.41.71-.68,1-.98.41-.42-.89-.43-2.86-.32l.12-.53c1.17-.35,2.99-.55,3.21-1.74.2-1.04.44-3.82.44-3.82.17-1.58-1.03-2.55-1.71-2.34-.63.2-1.56.71-1.7.94-.23.37.18.93.13,1.71-.02.44-1.45.47-3.1.36-.69-.04-1.88,1.27-2.17,1.33-.29.06-.87.07-1.36.09-.37.01-.77-.74-1.42-.78-.36-.02-.89.72-1.14.7-.77-.06-1.58-.34-2.29-.68-.23-.11.2-1.53.15-1.61-.05-.08-1.1-.11-1.4.09-.22.14-.82.69-.95.71-2.32.44-3.16.09-3.16.09.02-.78.16-1.79.31-1.94.58-.59,1.74-1.57,1.56-1.9-.12-.22-1.2-.94-.99-1.28.12-.2.36-.55.46-.67.27-.34.89.11,1.24-.08.34-.19.55-.78.68-.83.19-.06.71-.08,1.06-.07.23.01.56.94.73.94.41,0,.86.06,1.01-.22.25-.45.39-1.25.38-1.58,0-.54-1.55-.98-1.56-1.27-.01-.29.48-1.91.75-2,.41-.14,1.14-.42,1.1-.68-.13-.79-.55-2.37-.34-2.56.4-.36.97-.72,1.36-.98.26-.18.66.03,1.05.21.69.31,1.21.05,1.38-.23.16-.28.11-1.91.33-2.06.35-.23.89-.5,1.08-.61.24-.14,1.11.41,1.26.24.5-.58.8-.98.72-1.27-.14-.54-.54-1.83-.42-2.06.21-.42.33-.82.64-1.22.32-.41,1.47-.18,1.93-.58.64-.55.33-1.07,1.16-1.16,1.19-.13,2.51-1.18,2.89-1.35.77-.35,3.11.18,3.11.18.4-.03,1.11-.67,1.46-.71.39-.05,1.63.18,2,.35.29.13.33,1.42,1,1.64.39.13,1,.34,1.6.42,1.36.17,1.77-.93,2.24-.82.57.14,1.15.55,1.65,1.21.37.47-.26,2.17.62,2.54,1.11.47,2.29,1.71,2.2,2.06-.13.5-.7,1.48-.44,1.84.14.19,1.04-.05,1.39-.13.29-.06,1.16.12,1.38.38.24.28.6.83.97,1.01.59.29,1.48.69,1.57.94.29.85-.41,2.03-.29,2.43,0,.03,1.12.4,1.24.72.07.18-.04,2.29-.04,2.29,0,0,.97-.33,1.74-.05.46.17.66.74.85,1.43.05.18.65.27.71.42.35.83.31,1.38-.03,1.53-.77.32-2.55.94-2.3,1.65.23.64.56.69.88.73.74.09,1.59.09,2.23.39.62.29,1.13,1.37,1.02,1.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m264.31,23.2l-.67.47s.09.09.11.15l.65-.41c-.01-.06-.05-.15-.09-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m264.38,23.36l-.65.42s0,.01,0,.02c.01.03.02.16.02.3l.65-.43s0-.09,0-.13c0-.07-.01-.13-.03-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m264.41,23.64l-.65.43c0,.14,0,.35,0,.54l.65-.48c0-.14,0-.32,0-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m264.42,24.11l-.65.47c-.01.67-.06,1.54-.06,1.54,0,0,.04-.01.05-.02l.76-.96s-.07,0-.08.01c-.05,0-.01-.21-.01-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m261.05,18.44l-.59.54c.1.12.22.28.34.4l.61-.51c-.13-.12-.23-.26-.36-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m261.39,18.85l-.61.5c.08.09.18.19.28.26l.62-.56c-.13-.07-.21-.13-.28-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m264.49,25.15l-.76.96c.05-.02.26-.08.53-.13l.76-.85c-.17-.01-.37,0-.53.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.23,25.99c.07-.01.16-.03.24-.03l.72-.8c-.07-.01-.15-.02-.21-.02l-.75.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m260.26,18.72c.06.07.16.2.24.29l.58-.54c-.08-.11-.2-.26-.34-.41-.16-.18-.39-.3-.65-.37l-.73.67c.35.06.76.19.9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m246.29,9.36l-.06-.74c-.21.09-.47.24-.66.36l.06.77c.21-.12.45-.28.65-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m265.16,25.15l-.72.81c.05,0,.14-.01.19-.02l.69-.76s-.12-.02-.17-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m265.3,25.17l-.7.77c.28-.02.6,0,.88.11l.45-.66c-.21-.12-.43-.18-.64-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m261.25,19.73c.05.03.14.07.2.09l.64-.59c-.07-.03-.17-.08-.24-.11-.08-.03-.14-.07-.2-.1l-.61.56c.07.06.15.11.22.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m246.65,9.22c.07,0,.18,0,.31,0l.04-.7c-.09,0-.21-.02-.28-.02-.15,0-.33.05-.51.13l.06.74c.15-.08.28-.15.38-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m248.38,9.48l.45-.57c-.48-.15-1.32-.34-1.86-.39l-.04.7c.41.03,1.06.14,1.45.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m248.61,9.56c.08.03.15.16.21.35l.5-.63c-.1-.16-.21-.28-.34-.32-.05-.02-.11-.04-.17-.06l-.45.57c.1.03.19.06.26.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m249.01,10.43l.52-.7c-.06-.16-.15-.34-.23-.48l-.49.62c.06.15.12.37.2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m249.46,11.13l.46-.63c-.17-.11-.27-.47-.41-.8l-.52.7c.1.27.24.57.47.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m249.63,11.21c.41.15,1.31.45,1.89.45l.09-.73c-.44.03-1.42-.22-1.71-.45l-.46.63c.06.05.12.08.19.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m252.95,11.05l.1-.93c-.26.1-.49.29-.72.46l-.16.97c.32-.12.55-.31.78-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m252.2,11.54l.16-.98c-.28.21-.52.37-.78.38l-.09.73c.27,0,.5-.04.71-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m253.47,10.82s.1.03.15.04l.14-.72c-.16-.06-.29-.09-.39-.09-.12,0-.24.03-.36.08l-.1.95c.21-.17.37-.3.55-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m254.09,11.08l.15-.72c-.17-.1-.36-.18-.5-.23l-.14.72c.17.05.34.13.49.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m254.52,11.39l.27-.68c-.19-.14-.4-.27-.58-.37l-.15.72c.16.09.3.19.46.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m255.05,11.95l.59-.44c-.21-.28-.55-.59-.88-.82l-.27.67c.18.16.38.36.56.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m255.18,12.16l.62-.4c-.02-.05-.04-.08-.08-.15-.03-.05-.07-.09-.1-.13l-.59.44s.05.06.08.1c.02.02.05.06.07.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m255.22,13.25l.74-.53c-.01-.37-.05-.76-.19-1.02l-.6.42c.1.25.06.7.06,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m255.36,14.21l.65-.49c-.05-.24-.04-.65-.05-1.03l-.74.53c0,.37.01.74.14.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m255.51,14.42l.63-.48c-.08-.04-.12-.14-.14-.25l-.65.5c.04.08.09.16.17.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m256.11,13.93l-.63.46c.06.07.14.12.23.16.04.02.1.04.14.06l.61-.46c-.1-.07-.24-.16-.35-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m256.37,14.91l.56-.41c-.15-.12-.34-.25-.5-.36l-.61.46c.17.08.39.2.55.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m257.65,16.05l.54-.39c-.31-.37-.79-.81-1.29-1.18l-.56.42c.6.38,1.08.86,1.31,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m257.83,16.31l.55-.41c-.05-.07-.14-.18-.21-.27l-.54.39c.07.09.14.19.2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m257.91,16.61l.63-.45c-.04-.09-.11-.2-.18-.29l-.55.4c.07.12.12.24.1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m257.92,16.6c-.04.13-.12.35-.19.53l.92-.62c0-.12-.06-.25-.12-.37l-.61.44s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m257.52,18.49l.94-.89c-.17-.05.05-.47.17-.95.01-.05.02-.11,0-.17l-.9.61c-.27.68-.41,1.13-.25,1.38,0,.01.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m257.77,18.53l1.05-.96c-.1,0-.22.02-.27.03-.05,0-.08,0-.1-.01l-.94.87c.04.05.13.07.27.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m258.88,18.35c.1-.02.31-.02.52.02l.72-.67c-.45-.14-1.02-.15-1.34-.12l-1.05.96c.33,0,.89-.13,1.15-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m262.19,20.2l.71-.52c-.27-.18-.58-.33-.85-.46l-.64.59c.24.12.54.26.78.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m262.58,20.44l.7-.44c-.11-.13-.27-.25-.42-.35l-.71.53c.15.08.3.17.42.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m262.81,20.7l.68-.36c-.04-.12-.13-.26-.23-.36l-.71.44c.1.07.22.16.25.25,0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m262.78,21.78l.76-.47c.03-.36.03-.76-.07-1l-.68.36c.11.33.07.74-.01,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m262.5,23.1l.04.02.77-.49v-.05c.04-.09.18-.69.23-1.29l-.76.47c-.13.57-.36,1.1-.29,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m262.86,23.25l.73-.52c-.18-.07-.27-.11-.26-.16l-.83.52s.17.07.36.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m263.66,23.69l.67-.45c-.16-.31-.55-.44-.78-.53l-.73.52c.27.11.66.29.84.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m265.91,25.38l-.45.67c.13.05.25.13.36.27l.47-.61c-.11-.13-.24-.25-.38-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m266.59,26.21c-.09-.2-.19-.38-.32-.53l-.47.61c.11.12.21.3.28.5l.51-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m266.3,27.46c.02.07.11.12.26.19l.54-.61s-.09-.06-.12-.08c-.16-.12-.26-.44-.41-.78l-.51.57c.08.21.16.45.23.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m267.07,27.02l-.55.62c.2.08.45.15.49.25v.04s.49-.6.49-.6c-.11-.09-.28-.2-.43-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m267.48,27.29l-.46.59s.05.13.07.18l.55-.6c-.05-.07-.1-.12-.16-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m267.14,29.25l.67.21c.18-.45.18-1.15-.16-1.96-.01-.03-.03-.05-.05-.08l-.55.59c.22.57.25,1.01.08,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m266.98,29.38c-.34.14-.9.35-1.37.6l.86.37c.38-.18.85-.39,1.01-.47.14-.07.27-.22.35-.45l-.67-.21c-.05.07-.11.12-.19.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m266.5,30.33l-.86-.38c-.16.08-.35.19-.48.28l.89.3c.12-.05.3-.14.45-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m265.19,30.22c-.2.13-.39.29-.47.45l.93.09c.05-.05.13-.1.18-.12.04-.02.14-.06.26-.12l-.9-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m265.68,30.73l-.94-.09c-.08.13-.12.28-.05.44l.86-.11c-.02-.08.06-.17.14-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m265.54,30.94l-.87.11c.05.13.11.26.17.36l.88-.35c-.15,0-.18-.06-.18-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m265.13,31.67l.91-.6c-.15,0-.29-.02-.36-.03l-.85.33c.09.13.18.23.3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m265.57,31.8s.12.01.17.02l.96-.69c-.26-.03-.52-.05-.7-.06l-.9.59c.15.09.31.12.46.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m266.89,31.94l.87-.6c-.36-.11-.76-.17-1.09-.21l-.96.69c.37.04.8.06,1.18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m267.8,32.19c.08.04.17.09.26.17l.64-.45c-.21-.23-.44-.4-.68-.49-.1-.04-.2-.07-.3-.1l-.87.61c.34.05.66.12.94.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m268.39,32.72l.62-.41c-.08-.14-.22-.32-.34-.44l-.64.46c.12.1.25.23.36.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m268.81,34.05c-.02.08-.06.17-.12.24l.69.4c.09-.14.15-.31.16-.48.05-.58-.16-1.34-.54-1.93l-.62.41c.32.43.51,1.01.44,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m269.4,34.66l-.68-.4c-.31.41-1.23.51-2.06.52l.26.78c.98-.04,2.09-.23,2.48-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m265.58,34.76c-.11,0-.22.01-.33.05l.22.75h.03c.11-.02.73.03,1.45,0l-.26-.78c-.46,0-.87-.02-1.11-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m264.6,35.38l.33.94c.26-.21.29-.73.57-.77l-.22-.76c-.34.09-.56.35-.68.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m264.96,36.29l-.35-.94c-.09.15-.14.33-.14.33l.27.74c.07-.02.13-.05.16-.07.02-.02.04-.03.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m262.43,35.81c-2.12-.04-2.67-.84-2.67-.84h-.03s-.24.9-.24.9c.04,0,.11.04.17.08.68.41,1.72.66,2.75.66.91,0,1.96-.07,2.36-.21l-.29-.77s-1.36.2-2.06.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m258.67,35.52l-.27,1.2c.39-.21.67-.52.81-.65.18-.17.24-.22.32-.19l.24-.91c-.52,0-.79.24-1.1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m257.76,36.12l-.18.83c.38,0,.62-.12.84-.24l.27-1.21c-.47.48-.81.59-.93.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m256.65,35.23h-.03s-.41.8-.41.8h.04c.39.59.85.92,1.37.92l.18-.84c-.51.16-1.15-.88-1.15-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m252.29,34.9l-.46.66c.56.33,1.62.44,2.55.47l.34-.77c-1.08-.04-2.18-.14-2.43-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m250.03,32.33c-.16,0-.36,0-.52,0l.14.76c.1-.02.17.04.25.11.48.37,1.62,2.21,1.96,2.38l.46-.66c-.6-.42-1.84-2.58-2.29-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m249.54,32.33c-.31.02-.4.04-.57.12l.39.73c.09-.07.21-.08.32-.09l-.14-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m248.58,32.87l.63.7c.02-.23.08-.34.19-.41l-.39-.72c-.16.08-.31.22-.42.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m254.69,35.26l-.34.77c.74.03,1.47,0,1.9,0l.4-.8c-.51.05-1.26.06-1.96.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m248.4,33.91l.85.56c-.03-.34-.07-.71-.03-.96l-.61-.68c-.14.26-.22.63-.2,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m248.93,37.87l.72-.24c-.05-.25-.32-2.18-.42-3.19l-.85-.56c.02.59.41,3.7.54,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m249.65,37.62l-.73.22c.05.16.15.33.29.49l.67-.42c-.15-.12-.21-.21-.23-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m249.84,37.88l-.66.41c.22.26.55.5.94.71l.5-.64c-.31-.16-.61-.33-.77-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m251.28,39.52l.4-.68c-.36-.15-.78-.34-1.11-.51l-.5.64c.36.2.81.39,1.21.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m252.26,39.9l.38-.66c-.22-.1-.61-.25-.99-.41l-.4.68c.35.14.72.28,1.01.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m252.69,40.11l.48-.56c-.09-.13-.45-.27-.56-.32l-.38.66c.16.07.34.15.47.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m252.76,40.62l.72.67c.15-.11.02-.86-.13-1.34-.07-.21-.12-.35-.2-.44l-.48.57.1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m251.69,40.45l.68.75c.3.04.62.09.86.13.17.02.23,0,.26-.07l-.76-.69c-.27-.04-.67-.09-1.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m250.14,42.25l.61.77c.17-.09.14-.62.12-.98l-.73-.23v.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m250.56,41.1c.64-.03,1.28.03,1.85.11l-.68-.75c-1.11-.11-2.51-.19-2.57.15l1.36.58c-.03-.07.02-.08.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m250.5,41.12l-1.34-.55c-.02.06,0,.12.06.21.21.25.65.67.95,1.08l.69.22c-.01-.15-.04-.32-.07-.41-.08-.25-.33-.48-.29-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m249.84,42.07l.04.84c.52.2.8.19.9.09l-.64-.81c-.08-.03-.2-.09-.3-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m245.91,41.02l-.17.79c1.67.1,3.01.62,3.79.97.14.06.26.11.37.15l-.04-.84c-.78-.33-2.25-.93-3.96-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m240.83,42.06l-.37.97c.34-.13,2.47-1.41,5.31-1.22l.17-.79c-2.08-.16-3.68.36-5.11,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m240.53,42.21l-.53.9c.09.06.27.02.53-.09l.37-.98c-.11.05-.26.12-.36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m239.93,43.03s.05.08.1.1l.53-.94-.04-.49-.74-.02c-.12.37.09,1.21.14,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m240.3,41.04c.2.06-.46.38-.52.67l.75.02c.44-.41.71-.68,1-.98.05-.05.1-.12.07-.18l-1.3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m240.81,40.37l-.84.65c.29,0,.35.02.37.05l1.27-.45c0-.14-.28-.22-.8-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m238.61,40.41l-.74.53c.14.28,1.25.05,2.14.09l.84-.65c-.52-.03-1.34-.01-2.24.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m238.81,39.87l-.42-.56c-.26.22-.45.86-.54,1.53,0,.06,0,.1.04.13l.78-.57.14-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m240.2,39.55l-.57-.62c-.38.12-.92.25-1.14.33-.04.01-.09.05-.13.09l.43.58c.41-.12.99-.25,1.4-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m241.04,39.24l-.61-.61c-.25.12-.57.23-.84.31l.57.62c.3-.09.62-.19.89-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m241.75,38.71l-.6-.59c-.15.21-.44.38-.75.52l.61.61c.29-.13.55-.31.74-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m242,38.18c.2-1.04.46-3.97.46-4.14l-.81.23c-.08,1.03-.22,2.95-.39,3.64-.02.08-.06.16-.12.24l.6.59c.13-.16.23-.34.27-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m242,32.61l-.6.45c.18.27.29.64.24,1.24l.81-.23c0-.58-.19-1.11-.45-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m240.72,31.96c-.62.19-1.63.74-1.75.97l.82.55c-.09-.36.96-.79,1.15-.78.12,0,.32.13.48.38l.6-.45c-.38-.53-.92-.79-1.3-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m238.97,32.92c-.16.25-.02.59.07,1l.87.66c.01-.44-.09-.83-.14-1.12l-.8-.55s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m239.12,34.62s-.01.08-.05.12l.51.57c.22-.2.35-.46.34-.77l-.88-.67c.05.22.09.47.08.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m238.53,34.96l.32.66c.36-.05.59-.18.75-.32l-.52-.57c-.07.11-.26.19-.55.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m236,34.96l.17.74c.58-.02,2.01,0,2.71-.1l-.32-.66c-.68.12-1.75.05-2.55.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m234.75,35.64l.23.82c.46-.38.83-.71,1.01-.74.05,0,.12-.01.21-.01l-.17-.74c-.35-.02-.83.31-1.28.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m234.78,35.61c-.46.36-.79.69-.96.7l.21.74c.31-.04.71-.4.99-.62l-.23-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m232.51,36.39c-.33.01-.71-.61-1.25-.75l-.04.76c.08.02.15.06.22.13.21.21.52.59.99.6.47.01,1.34-.03,1.64-.08l-.21-.74c-.29.06-.85.06-1.34.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m231.09,35.61c-.25-.02-.58.33-.83.54l.15.82c.24-.14.44-.36.62-.51.04-.03.12-.08.23-.05l.04-.76c-.07-.02-.14-.04-.22-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m230.28,36.12c-.14.11-.26.2-.34.19h-.02s.05.77.05.77c.18,0,.33-.06.47-.14l-.15-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m227.68,35.64s-.03-.02-.05-.07l-.64.41c.14.2.36.34.45.38.96.45,2.15.72,2.57.72l-.06-.77c-.77-.06-1.55-.34-2.26-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m227.75,34.54l-.85.65c-.01.1-.03.24-.04.37-.02.17.05.33.15.46l.63-.41c-.08-.14.01-.6.11-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m227.84,34.03h0s-.03-.01-.03-.01l-.97.79h.04c.06,0,.05.11.02.41l.84-.65c.06-.28.11-.51.09-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m226.57,34.05l.07.93s.11-.08.15-.11c.04-.03.07-.05.09-.05l.96-.78c-.04-.07-.84-.1-1.27.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m226.39,34.12c-.15.1-.5.4-.74.58l.34.74c.19-.11.41-.28.68-.5l-.07-.91c-.09.02-.17.05-.22.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m225.44,34.82c-2.38.46-3.16.09-3.16.09l-.68.38.02.04c.31.4,1.68.65,3.94.26.18-.03.32-.08.46-.17l-.35-.75c-.11.08-.19.14-.23.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m222.52,33.27l-.69-.29c-.22.79-.33,2.19-.21,2.34l.7-.4c.02-.57.09-1.27.19-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m222.62,33.02c.07-.08.19-.19.28-.28l-.68-.45c-.08.09-.19.21-.24.3-.06.1-.11.25-.16.43l.69.29c.04-.14.07-.24.11-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m224.19,31.14l-1.09.13s.03.04.03.04c.09.15-.55.6-.95,1.03l.68.45c.57-.55,1.41-1.33,1.32-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m224.18,31.11c-.06-.11-.37-.35-.61-.58l-.93.07c.11.19.3.46.49.7l1.07-.12s0-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m223.17,29.91l-.82-.03c0,.17.1.4.31.74l.94-.07c-.23-.21-.46-.47-.43-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m223.35,29.6l-.78-.23c-.05.09-.14.25-.19.35-.03.05-.03.12-.03.19l.81.03c0-.06.02-.09.18-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m223.65,29.17s.08-.08.15-.1l-.28-.72c-.36.18-.71.61-.97,1.06l.78.22c.12-.18.26-.38.33-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m224.31,29.1l-.12-.84c-.34,0-.45-.03-.71.11l.28.71c.14-.07.32-.03.54.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m224.16,28.25l.12.84c.16.03.35.08.49.05l-.15-.9c-.11.03-.29.02-.46.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m224.69,28.19s-.08.04-.11.05l.15.9c.05,0,.11-.02.17-.06l-.22-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m225.3,28.63l-.26-.88c-.17.19-.31.43-.38.47l.22.88c.16-.09.29-.26.42-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m225.02,27.78l.26.89c.08-.12.16-.27.22-.34l-.22-.78c-.11.07-.19.15-.26.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m225.56,28.27s.06-.02.1-.02l-.09-.8c-.06,0-.14.03-.18.04-.05.02-.09.04-.14.07l.22.8s.06-.08.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m226.41,28.2l.05-.78c-.35-.01-.68-.01-.92.03l.09.8c.17-.04.5-.06.78-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m226.43,27.42l-.05.78c.07,0,.17,0,.23,0l.19-.77c-.11,0-.26-.01-.37-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m226.81,27.43s-.03,0-.04,0l-.19.77s.02,0,.03,0c.02,0,.05.01.1.05l.35-.77c-.08-.03-.16-.05-.24-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m226.95,28.6l.37-.88c-.1-.14-.19-.21-.3-.25l-.34.76c.08.06.17.19.27.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m227.21,29.04l.36-.93c-.09-.13-.19-.32-.28-.43l-.37.88c.09.15.2.35.29.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m227.34,29.15s.12,0,.17,0l.25-.82c-.08-.08-.14-.15-.22-.27l-.36.93c.06.09.12.16.16.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m228.25,29.05l-.35-.72-.03.02c-.07.04-.08.02-.14-.04l-.26.85c.28,0,.59.01.78-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m228.38,28.92c.03-.05.06-.13.09-.19l-.51-.6c-.02.12-.05.19-.08.21,0,0,0,0,0,0l.35.72c.07-.03.12-.08.16-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m228.6,28.35l-.6-.5c0,.11-.02.24-.04.32l.5.59c.05-.12.1-.27.14-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m228.76,27.33s0-.06-.02-.1l-.79.23c.05.07.05.28.04.41l.6.5c.11-.39.17-.82.17-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m228.25,26.75l-.84.32c.26.17.53.33.55.42l.78-.23c-.04-.17-.24-.35-.5-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m227.65,26.41l-.77.28c.17.14.39.29.57.4l.84-.32c-.19-.12-.44-.26-.63-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m227.19,26.01l-.69.18c.04.19.21.37.41.53l.78-.29c-.35-.2-.51-.3-.5-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.53,25.86c-.01.06-.03.14-.03.17-.01.06,0,.12.01.18l.68-.18s.01-.14.03-.25l-.7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m227.27,25.61l-.68-.03c-.02.1-.05.23-.07.3l.7-.08c.01-.05.03-.13.05-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m227.78,24.25l-.61-.35c-.26.48-.47,1.23-.59,1.72l.68.03c.11-.42.33-1.08.52-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m227.16,23.93l.61.35c.04-.07.09-.14.15-.19l-.63-.37s-.09.14-.12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m228.12,24.02l-.68-.46c-.07.05-.13.13-.18.2l.63.36s.04-.04.06-.04c.04-.01.13-.04.17-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m228.76,23.72l-.7-.45c-.16.08-.35.15-.57.25-.03.01-.06.03-.09.06l.67.45c.21-.08.49-.19.69-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m228.27,23.07s0,.04,0,.05c-.04.06-.12.11-.23.16l.7.45c.18-.11.33-.24.31-.36l-.77-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m229.05,23.38c-.04-.27-.13-.66-.2-1.03l-.72-.18c.07.45.16.84.14.93l.77.3s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m228.66,21.18l-.65-.18c0,.37.06.83.12,1.2l.72.18c-.09-.43-.17-.89-.19-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m228.72,20.83s.13-.11.18-.16l-.64-.46c-.2.16-.25.45-.25.82l.65.18c-.01-.19,0-.33.06-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m229.88,19.97l-.24-.8c-.41.28-1.07.77-1.41,1.07l.64.46c.31-.26.71-.53,1.02-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m230.05,19.86c.06-.04.14-.07.24-.07l-.04-.85c-.17,0-.31.02-.43.09-.06.04-.14.09-.22.15l.24.8c.07-.05.14-.09.2-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m230.8,19.93v-.87c-.19-.07-.4-.12-.57-.12l.04.85c.15,0,.34.05.53.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m230.77,19.06v.86c.42.2.86.42,1.37.2l-.29-.73c-.13.1-.61-.18-1.08-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m232.51,19.81l-.61-.53c0,.07-.02.1-.05.12l.26.74c.19-.07.34-.19.4-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m231.95,18.43c-.02.24-.04.55-.06.88l.6.52c.06-.11.1-.44.12-.78l-.67-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m232.65,18.71l-.66-.64c-.02.11-.03.26-.04.39l.67.62c0-.11.02-.26.03-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m232.75,17.93l-.54-.57c-.12.15-.19.4-.23.73l.66.64c.02-.3.05-.62.1-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m232.83,17.78c.06-.04.15-.1.22-.14l-.5-.55c-.08.06-.19.14-.25.18-.04.03-.07.07-.1.11l.55.58c.02-.1.05-.16.09-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m233.71,17.26l-.22-.76c-.32.16-.72.43-.98.62l.5.54c.23-.14.51-.3.7-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m233.88,17.17s.1-.03.19-.01l-.24-.79c-.12.03-.24.09-.37.15l.22.76c.08-.05.15-.08.2-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m234.24,17.2l-.23-.84c-.07-.02-.14,0-.21.02l.24.78c.05,0,.12.02.2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m234.75,17.37l-.23-.86c-.16-.06-.39-.13-.54-.16l.23.84c.16.04.37.13.54.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m235.16,17.4l.02-.03-.29-.76h-.03s-.2-.06-.37-.12l.23.87c.21.07.38.11.44.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m235.41,17.11l-.38-.65c-.07.1-.13.16-.17.16l.3.79c.08-.09.18-.21.25-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m235.89,16.3l-.73-.15v.03c0,.05-.07.19-.15.3l.38.65c.26-.32.46-.61.5-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m235.89,16.11c-.02-.06-.04-.16-.07-.24l-.77-.15c.06.23.11.43.11.46l.72.15c.02-.08.02-.15,0-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m235.6,15.03l-.74-.16c.06.3.15.64.21.88l.77.16c-.07-.24-.16-.58-.24-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m235.48,14.03l-.69-.18c-.02.06-.03.14-.04.19-.02.17.03.5.11.85l.74.16c-.15-.6-.2-.9-.12-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m235.94,13.09l-.44-.61c-.27.39-.61,1-.71,1.41l.68.17c.16-.33.28-.66.48-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m236.11,12.84s.08-.09.17-.13l-.34-.71c-.11.07-.2.15-.27.24-.06.07-.12.17-.2.28l.45.6c.05-.09.11-.18.18-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m236.74,12.58l-.33-.76c-.19.04-.36.1-.5.2l.34.71c.12-.07.28-.12.5-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m236.38,11.83l.33.76c.46-.08,1.07-.08,1.35-.35l-.3-.88c-.22.4-.85.35-1.38.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m238.47,11.66l-.33-.91c-.2.19-.29.4-.35.54-.01.04-.03.07-.05.1l.3.87s0,0,0,0c.22-.19.34-.39.43-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m239.21,11.1l-.16-.74c-.47.06-.76.24-.94.42l.34.93c.15-.31.19-.55.77-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m240.16,10.83l-.17-.72c-.28.12-.59.21-.87.24-.03,0-.06,0-.09.01l.16.74c.31-.03.65-.14.98-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m241.16,10.31l-.2-.73c-.29.19-.65.4-1,.54l.17.72c.36-.15.73-.35,1.03-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m242.03,9.78l-.16-.77c-.11.04-.24.1-.32.16-.17.13-.38.28-.62.43l.2.73c.38-.22.71-.45.9-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m242.08,9.75c.29-.13.81-.14,1.33-.1l-.04-.7c-.54-.07-1.12-.09-1.53.06l.16.78s.06-.03.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m244.59,9.82l-.04-.66c-.34-.06-.79-.15-1.21-.2l.04.7c.42.03.87.1,1.21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m245.18,9.93h.03s-.02-.72-.02-.72c-.1.04-.38,0-.67-.05l.04.66c.36.06.61.12.61.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m245.67,9.73l-.06-.77c-.2.12-.38.24-.45.25l.02.72c.13,0,.3-.09.49-.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m243.95,24.55c-.1.22-.33,1.1-.72,1.36-.51.35-1.46-.06-1.71.1-.22.13-.25.58.06.74,1,.5,1.94.91,3.2,1.71.1.06.25-.05.31-.24s.57-3.41.52-3.54c-.19-.43-1.57-.32-1.66-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m247.67,25.17c-.03.08-.48,3.53-.4,3.58.07.04,1.13-1.14,3.06-2.43.1-.07.05-.28.05-.31-.02-.17-.79-1.09-.86-1.09-.2,0-1.84.21-1.85.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m248.44,30.52c-.02.19,1.22.43,2.31.07.26-.09.65-1.14,1.15-1.31s1.71.34,2.1,0c.31-.27.24-1.09-.2-1.11-.96-.05-1.17-.12-2.24-.4-.11-.03-2.97,1.59-3.11,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m239.88,28.29c-.1.06-.37.76-.66.97-.14.12-.33.11-.5.11-.4,0-.53-.07-.92-.21-.18-.08-.36-.19-.55-.18-.32,0-.65.37-.79.75-.29.88,1.4,1.29,1.64,1.37.31.08,1-.15,1.68-.54.42-.24.89-.37,1.24-.37s.81.23,1.42.28c.11,0,.24-.14.27-.19.08-.15.09-.41.02-.51-.16-.24-1.73-1.13-2.09-1.31-.19-.1-.64-.24-.76-.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m261.07,30.22c.01.1,0,.45.13.62.05.08.67.06.69-.06.05-.23-.04-.52-.46-.84-.08-.06-.37.16-.36.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m225.32,31.78c-.11.11-.06.81.03.89.26.22,1.06-.37,1.2-.55.12-.16.16-.28.14-.4-.04-.28-.15-.32-.25-.32s-1.02.28-1.13.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m262.73,27.77c-.27.01-.42.19-.42.48s.19.52.83.48c.78-.05.77.38,1.1.38.72,0,.57-.7.58-1.01,0-.35-1.26-.36-2.1-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m258.38,20.69c-.3,0-.45.46-.36.58s.48-.04.97.29c.19.12.76,1.03.85,1.23s.71.44.91.32c.22-.13-.22-1.47-.36-1.54-.52-.24-.89-.63-1.17-.77-.24-.12-.73-.13-.85-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m260.88,25.75c-.21.16-.32.46-.22.63.06.11.77.39,1.11.27.18-.06.23-.3.18-.45s-.34-.98-.6-.98c-.17,0-.26.37-.47.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m231.99,26.09c-.47.3-.75.89-.89,1.11-.1.17-.21.51-.12.51.14.01.36,0,.49-.22.35-.55.81-.29,1-.48.51-.48.51-1.01.44-1.08-.07-.08-.54-.09-.93.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m255.42,17.8c-.21.11-.28,1.24.03,1.53.11.1.49,0,.58-.1.18-.2.07-.95-.28-1.29-.1-.1-.24-.18-.33-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m256.96,23.66c-.23.08-.72.52-.61.7.1.17.26.19.82.11.23-.03.5.41.64.48s.67.24.82.23.38-.31.35-.46c-.02-.08-.47-.39-.59-.53-.3-.36-.09-.59-.19-.72-.09-.11-1.04.12-1.24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m250.35,21.03c-.01.11.34.35.46.32.16-.03.34-.16.56-.18.49-.05,1.33.58,1.61.49.12-.04.29-.41.21-.6s-.76-.49-1.02-.47c-.45.05-.78-.28-.95-.2-.68.32-.83.27-.87.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m251.75,17.2c.03.12.17.3.66.71.2.17.24.56.49.86.04.05.45.17.47.08.07-.37-.23-.51-.21-.9.04-.62.03-.79-.07-.93s-.67-.23-.88-.23-.51.25-.45.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m245.94,14.36c-.06.27.4.72.56.72.19,0,.64-.39,1.06-.37.64.03.64-.63.62-.67-.08-.16-.42-.25-.47-.22-.49.23-.71.05-.83-.02-.27-.15-.79-.14-.93.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m251.96,14.29c.08.25.2.22.31.13s.33-.27.62-.24c.41.05.89,1.29,1.05,1.24.11-.03.16-.55.13-.79s-.29-.71-.49-.93c-.21-.24-.75-.55-1.01-.54-.35,0-.68.88-.6,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m247.73,16.63c-.33.47-.65.5-1,.82-.25.23-.27.85.05.85.3,0,.34-.36,1.22-.72.24-.1.51-.35,1.59-.19.31.05.44-.33.4-.39-.1-.15-.75-.42-1.13-.54-.35-.11-1.05.05-1.13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m246.74,11.32c-.16.29.08.88.73.94.48.04.71-.37.57-.8-.1-.31-1.12-.47-1.3-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m242.62,11.75c-.06.18-.04.55.15.63.17.08.35-.27.75-.23.58.07.63.49.77.49.27,0,.56-.37.37-.94-.02-.05-.1,0-.28-.15-.1-.08-.22-.31-.31-.31-.49,0-1.3.03-1.45.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m241.27,19.9c-.32.2-.83.59-.71,1.05.04.16.62.06.94-.02.82-.19.8-1.06.77-1.11-.16-.25-.46-.26-1,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m254.17,22.81c-.26.7-.26.96-.04,1.02.33.09.38-.06,1.11-.93.11-.13.52-.2.55-.21.12-.05.31-.33.29-.46s-.75-.48-.92-.46c-.24.03-.96.93-1,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m243.67,16.6c-.54.73-.49,1.64-.15,1.67.14.01.27-.27.3-.39.03-.14-.03-.32.13-.56.07-.11.22-.19.38-.18.05,0,.19-.64-.06-.78-.24-.13-.4-.03-.6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m233.64,22.59c-.17.11-.36.5-.37.68-.02.24.22.51.69.38.33-.09.56-.38,1.16-.69.3-.15.32-.51.17-.54-.2-.05-.47-.13-.73-.17-.3-.04-.67.16-.93.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m238.98,13.85c-.18.1-.55.11-.81.16-.4.08-.65.5-.73.83s.39,1.85.47,1.91c.12.09.35.08.43.02.15-.1-.18-1.52.1-1.86.24-.29,1.7-.63,1.84-.86.09-.15-.04-.89-.15-.91-.22-.02-.87.55-1.15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m230.89,21.35c-.12.03-.48.3-.61.43-.19.18-.22.47-.16.64s.18.22.39.07c.31-.23.22-.26.75-.36.14-.03.18-.44.06-.62-.1-.16-.31-.18-.43-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m236.62,26.16c.06.02.6.51.39.76-.1.08-.21.02-.64.12-.36.07-.61.33-.82.52-.57.48-.91.56-.96.57-.08,0-.2-.03-.26-.1-.09-.11-.14-.34-.1-.54.02-.11.15-.47.32-.5.06,0,.58-.03.98-.3.41-.23.42-.6,1.08-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m234.24,19.77c-.11.12-.26.26-.26.49s.35.61.62.36c.42-.39.67-1.08.46-1.19-.19-.1-.66.16-.83.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m238.02,18.86c-.93.17-1.41.89-1.47,1.13-.05.21.15.44.28.44.24,0,.72-.74,1.02-.83.2-.06.5.03.93.16s.56.24.63.02-.04-.77-.26-.84-.68-.17-1.14-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m229.3,33.79c-.04.34.14.55.84.59.74.04.69-.41.62-.44-.71-.33-.82-.47-.97-.62-.04-.04-.44.06-.48.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m228.82,30.24c-.01.05-.02.35.07.47.06.08.2.15.26.17.14.04.27,0,.66-.31.16-.13.32-.12.44-.25.09-.09.05-.22.04-.28-.01-.09-.37-.43-.57-.43-.3,0-.88.53-.91.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m230.78,24.06c-.31.01-.51.03-.84.21-.36.2-.49.57-.46.81s.17.35.33.4c.14.05.43-.06.5-.25.06-.15.13-.44.63-.5.27-.03.46,0,.56-.16s.06-.44,0-.45c-.22-.06-.49-.07-.72-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m233.77,33.3c-.01.3.16.51.33.51s.48-.14.66-.16c.31-.02.43.09.47.02.11-.23-.03-.42-.08-.52-.1-.22-.38-.11-.51-.1-.25,0-.48-.22-.58-.22-.2,0-.29.36-.29.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m252.67,32.69c.08.17.63.46,1.25.31.16-.04.29-.44.11-.55-.34-.2-.77-.32-1.21-.18-.2.06-.22.27-.15.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m231.6,31.46c-.39.12-.56.23-.61.54-.04.22.17.28.54.29.59.02.87-.29.87-.56,0-.46-.45-.38-.79-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m256.02,33.29c.19.33.7.02,1.3.23.18.06.44.54.74.46.15-.04.32-.63.33-1,0-.28-.53-.42-.76-.34-.67.24-.92.28-1.37.35-.16.03-.25.27-.23.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m256.69,29.99c.04.15.95.04,1.28.27.46.33.88.37.93.26.18-.34-.04-.71-.26-.88s-.73-.33-.93-.32c-.96.07-1.07.52-1.03.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m262.67,32.62c-.2,0-.46.5-.87.48-.24-.01-.61-.22-.79-.21-.29.01-.62.56-.54.71s.62.45,1.43.45c.37,0,.49-.15.6-.3.2-.29.55-.34.63-.42.04-.04.05-.36.01-.43-.09-.17-.34-.28-.48-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m265.55,33.11c-.22.32.03.66.27.7.14.02.85-.12.9-.26.06-.17-.14-.61-.35-.65s-.69,0-.83.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m249.15,29.46l-.16-.14c-.39.38-.68.77-.73,1.09l.21.03c.03-.17.16-.48.67-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m248.27,30.41c-.01.06-.01.12,0,.18.02.11.14.2.32.26l.09-.2c-.12-.04-.18-.07-.2-.1,0-.02,0-.06,0-.11l-.21-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m249.51,30.74c-.4,0-.67-.04-.84-.09l-.1.19c.24.08.58.12.93.12.57,0,1.18-.09,1.43-.26l-.17-.15c-.21.1-.69.19-1.26.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m237.97,16.73l-.16.14c.1.13.52.14.63.05l-.15-.16c-.05.02-.2.02-.32-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m238.28,15.74c0,.08.08.86,0,1.01l.14.17s.04-.03.04-.05c.11-.24.05-.68.04-.93-.02-.35-.1-.79.07-.94l-.14-.16c-.22.19-.19.55-.17.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m265.55,33.51l-.21.05c.04.14.17.28.32.35l.12-.18c-.1-.05-.2-.14-.22-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m252.58,13.21c.13,0,.49.15.77.36l.11-.19c-.31-.23-.7-.39-.88-.39-.25,0-.45.21-.58.46l.19.1c.03-.05.19-.35.39-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m230.78,21.45c.06-.05.16-.1.35-.05l.07-.2c-.3-.09-.45,0-.55.08-.1.07-.2.14-.29.21l.14.17c.11-.08.25-.18.29-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m249.85,17.25c-.05.06-.11.1-.17.11l.02.21c.1-.01.19-.06.27-.13l-.12-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m237.72,30.92l-.07.2c.16.06.32.11.43.15l.07-.2s-.36-.12-.43-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m240.45,14.07c.02-.06.02-.2.01-.36h-.21c0,.13,0,.24,0,.29-.01.04-.03.06-.06.09l.18.13s.07-.09.09-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m244.38,16.62c.01.09,0,.19,0,.28l.21.04c.02-.13.02-.29,0-.42l-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m243.8,17.74c0,.25-.18.49-.28.49l.03.21c.24-.03.43-.35.45-.56s0-.32.09-.45l-.08-.23c-.14.11-.22.29-.22.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m262.03,26.65l-.17-.13s-.06.08-.09.09l.07.2s.12-.06.19-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m247.67,11.25l.07-.2c-.26-.08-.86-.2-1.13.15l.17.14c.14-.23.66-.16.9-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m248.01,11.49s.03.11.03.17l.21.06c0-.11,0-.21-.04-.3-.06-.19-.25-.31-.47-.38l-.08.2c.17.05.31.14.34.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m247.14,12.13l-.08.2c.68.3,1.17-.07,1.19-.61l-.22-.07c.02.42-.31.74-.9.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m246.75,11.7l-.21.05c.07.23.24.45.52.58l.09-.2c-.28-.14-.37-.36-.39-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m246.78,11.32l-.17-.13c-.11.15-.12.37-.07.55l.21-.04c-.05-.14-.04-.28.03-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m244.17,11.37c.11.13.26.32.46.34.05.06.06.21.05.36l.21.06c.03-.3-.04-.62-.23-.63-.14,0-.29-.25-.38-.34-.03-.03-.05-.05-.08-.06l-.1.19s.04.03.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m244.09,11.29l.11-.19c-.15-.09-1.21-.02-1.52.26l.16.14c.34-.23,1.18-.25,1.25-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m244.68,12.07c0,.14-.04.28-.08.34-.07.11-.25.21-.31.2-.05-.01-.17-.21-.31-.31-.16-.11-.35-.17-.54-.17v.22c.14,0,.29.05.41.13.13.09.23.31.38.34.13.03.32-.04.5-.25.1-.11.13-.31.15-.46l-.21-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m243.02,12.26l.07.21c.18-.14.3-.13.35-.13v-.22c-.06,0-.24,0-.42.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m242.82,12.37s-.03,0-.05,0l-.07.2s.08.02.12.02c.11,0,.2-.06.28-.11l-.08-.21c-.12.08-.16.11-.2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m242.4,11.89c-.01.27.08.6.31.67l.07-.2c-.13-.05-.17-.35-.16-.46h-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m242.84,11.51l-.16-.15c-.23.2-.28.38-.28.54h.22c0-.11.04-.24.22-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m246.84,13.83c.26.2.61.17.87.02.03-.02.14,0,.25.05l.11-.19c-.1-.05-.32-.13-.46-.05-.29.16-.54.08-.63,0-.14-.12-.72-.24-1.02.21l.19.11c.18-.27.58-.24.7-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m248.15,14.06c0,.05-.01.1-.02.14l.21.04c0-.05.02-.11.02-.17.01-.13-.13-.28-.31-.37l-.1.19c.1.05.18.12.2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m247.3,14.92c.16-.05.33-.02.5-.06.14-.03.45-.12.55-.62l-.21-.03c-.07.37-.27.42-.38.44-.15.03-.33,0-.51.07-.27.09-.56.31-.71.32-.08,0-.12-.04-.22-.12l-.15.16c.1.09.19.18.35.18.22,0,.55-.26.8-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m245.97,14.43h-.22c.02.26.23.5.4.65l.14-.16c-.16-.15-.3-.33-.32-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m246.14,13.98l-.18-.11c-.09.14-.22.4-.2.57h.22c-.02-.12.1-.34.17-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m253.49,13.69c.29.28.5.76.54.95,0,.04.01.1,0,.16l.21.04c0-.1,0-.19,0-.25-.05-.23-.28-.75-.61-1.06-.06-.05-.12-.1-.18-.15l-.11.19s.1.08.14.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m254.04,14.8c0,.19-.06.47-.11.6l.08.24c.12-.03.22-.49.23-.8l-.21-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m253.93,15.4c-.16-.15-.36-.51-.39-.56-.19-.33-.38-.67-.65-.69l-.02.21c.19.03.4.45.56.74.32.55.48.56.57.54l-.09-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m252.79,14.14c-.36,0-.56.29-.62.3h0s-.05,0-.07,0l-.07.2s.09.02.14.02c.22-.01.3-.3.62-.3.03,0,.07,0,.1,0v-.22s-.06,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m252.04,14.63l.06-.2c-.06,0-.07-.04-.11-.15-.02-.08.03-.43.19-.72l-.18-.11c-.18.33-.26.75-.21.9.05.16.1.26.25.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m252.1,16.6c-.09.01-.21.07-.31.16l.14.16c.07-.06.15-.11.2-.11.24-.03.54.04.7.09l.06-.21c-.2-.07-.55-.13-.79-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m253.33,17.97c0-.42.11-.65-.07-1.03-.06-.12-.21-.19-.37-.25l-.07.2c.12.04.21.08.23.12.16.23.06.63.06.95,0,.19.09.41.18.55.02.02.03.1.04.16l.22.05c0-.12-.03-.26-.07-.32-.05-.07-.15-.27-.15-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m252.91,18.73l-.11.19c.11.07.35.14.55.12.19-.01.2-.15.2-.32l-.22-.04c0,.06,0,.11,0,.15-.15.02-.38-.07-.42-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m252.65,18.2c-.13-.27-.26-.39-.51-.57l-.14.16c.22.16.36.28.47.54.09.21.2.53.34.6l.1-.19c-.1-.1-.2-.41-.26-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m251.87,17.31l-.17.14c.11.14.25.3.31.34l.13-.17s-.18-.19-.27-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m251.78,17.18s.03-.16.16-.27l-.15-.16c-.15.13-.27.33-.22.49.01.04.07.12.13.2l.16-.15c-.04-.06-.08-.1-.09-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m255.45,17.82c.11-.01.23.09.28.14l.15-.15c-.08-.09-.3-.26-.52-.19-.08.03-.17.19-.23.39l.2.09c.03-.11.08-.23.12-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m256.09,18.85l.22.04c-.02-.47-.13-.75-.43-1.09l-.15.16c.29.33.33.53.36.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m255.98,19.23c-.13.08-.4.12-.49.08l-.12.18c.18.12.6.02.74-.09s.19-.32.19-.51l-.22-.03c0,.16-.02.32-.11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m255.38,19.49s0,0,0,0l.11-.19c-.11-.08-.22-.39-.2-1.01,0-.05.02-.12.04-.19l-.2-.1c-.03.11-.06.22-.06.29-.01.45.03,1.03.3,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m248.51,16.26c-.16,0-.74.06-.9.23-.1.11-.26.31-.4.4-.03.02-.12.07-.22.13l.12.18c.07-.04.21-.13.22-.13.18-.11.37-.36.45-.44.04-.05.44-.15.73-.15s.53.08.91.25l.08-.2c-.53-.23-.74-.26-.99-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m250.17,17c.01-.15-.34-.34-.67-.48l-.07.2c.25.11.46.24.53.3,0,.03-.01.06-.02.09l.2.09c.02-.06.04-.13.05-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250.12,17.19l-.2-.08c-.02.05-.04.1-.08.14l.11.2c.08-.07.13-.16.17-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m249.57,17.35c-.53-.1-1.19-.03-1.47.13-.04.02-.07.04-.11.06l.07.21s.1-.05.15-.08c.19-.11.75-.22,1.31-.11.04,0,.11.02.19,0l-.03-.21s-.08,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m247.13,18.05c-.13.14-.27.22-.36.22-.03,0-.05,0-.08-.03l-.12.18c.06.04.12.06.19.06.14,0,.32-.08.51-.28.19-.2.5-.31.77-.45l-.08-.2c-.37.18-.64.29-.85.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m246.37,17.84c-.02.26.06.48.22.58l.11-.19c-.1-.06-.12-.24-.12-.36l-.21-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m247.12,17.2l-.11-.18c-.55.3-.61.6-.64.83l.21.03c0-.13.02-.39.53-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m243.81,16.49c.07-.09.21-.18.38-.12l.1-.19c-.29-.12-.53.04-.64.18-.07.08-.16.2-.23.3l.18.12c.06-.09.22-.29.22-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m244.28,16.17l-.09.2c.16.05.18.2.19.26l.2-.09c-.03-.13-.09-.28-.3-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m244.58,16.94l-.21-.04c-.01.09-.04.17-.06.21l.1.2c.09-.04.15-.23.17-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m244.31,17.11c-.05,0-.09,0-.12,0l-.04.25c.07-.06.13-.04.19-.04.02,0,.05,0,.07-.02l-.11-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m244.17,17.36l.03-.24c-.07.01-.13.05-.18.09l.07.24s.04-.06.07-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m243.43,18.18l-.11.19c.07.05.15.09.24.07l-.04-.21s-.08-.04-.09-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m243.33,18.38s0,0,0,0l.1-.2c-.07-.07-.11-.17-.12-.29l-.21.04c.02.18.09.34.23.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m243.53,16.87s.03-.06.06-.1l-.18-.12s-.06.09-.08.13c-.13.27-.29.77-.24,1.16l.21-.05c-.04-.31.09-.74.22-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m240.15,12.98c-.4,0-.93.58-1.27.74-.12.06-.6.11-.74.13-.27.04-.5.25-.65.48l.18.12c.12-.18.3-.35.51-.39.18-.03.59-.06.79-.15.29-.12.86-.7,1.16-.72l.1-.2s-.07-.02-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m240.22,12.99l-.09.2c.06.08.11.33.12.53h.21c-.02-.3-.1-.66-.24-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m240.36,14.22l-.19-.12c-.1.08-.92.37-.94.37l.12.18c.1-.04.86-.28,1-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m238.45,14.85l.13.17c.22-.19.77-.35.79-.36l-.13-.18s-.55.17-.8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m237.8,16.34c-.03-.11-.12-.44-.13-.48-.09-.29-.2-.68-.18-.95l-.21-.05c-.03.36.13.85.23,1.17.03.12.07.23.1.35.04.16.11.35.22.49l.16-.15c-.07-.09-.13-.24-.17-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m237.48,14.84c.02-.09.08-.25.18-.4l-.17-.13c-.12.18-.2.37-.23.49,0,.02,0,.04,0,.07l.21.04s0-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m241.93,19.68s.06,0,.09.01l.07-.2c-.05-.01-.11-.02-.16-.02-.31,0-.96.42-1.07.5l.13.18c.12-.1.7-.47.94-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m242.24,19.83s.02.19-.03.36l.2.07c.07-.25.06-.48,0-.55-.09-.13-.21-.2-.32-.23l-.08.2c.09.02.16.07.22.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m242.41,20.26l-.21-.06c-.07.26-.27.59-.71.7l.08.2c.49-.13.74-.51.83-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m241.48,20.9c-.13.03-.41.1-.64.1-.12,0-.23-.02-.25-.06l-.14.17c.09.08.23.11.39.11.24,0,.56-.07.75-.12l-.09-.2s-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m240.46,21.11l.13-.18s0,0,0,0c-.03-.14,0-.27.06-.38l-.21-.05c-.07.15-.12.51.03.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m241,20.13l-.13-.17c-.2.16-.35.34-.44.54l.21.05c.08-.16.22-.3.35-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m236.86,19.25l.15.16c.33-.27.82-.67,1.84-.5l.05-.21c-1.14-.19-1.69.26-2.04.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m239.19,18.77c-.08-.03-.18-.05-.29-.07l-.06.21c.1.02.2.04.27.06.1.04.18.15.23.29l.21-.07c-.07-.2-.19-.37-.37-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m239.35,19.27c.04.11.06.24.05.36l.21.06c.02-.15,0-.33-.06-.49l-.2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m239.61,19.68l-.21-.05c0,.08-.03.19-.07.23l.09.2c.11-.05.17-.2.19-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m239.32,19.86s0,0,0,0c-.23,0-.87-.28-1.11-.31l-.02.22c.34.07.82.31,1.12.31.04,0,.07-.01.11-.03l-.1-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m237.69,19.63l.09.2c.08-.05.2-.11.42-.06v-.22c-.24-.05-.41.02-.51.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m237.69,19.63c-.2.11-.34.31-.44.42-.21.23-.34.33-.42.33v.22c.21,0,.45-.26.56-.38.13-.14.25-.3.4-.39l-.09-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m236.72,20.32l-.14.17c.06.05.15.11.24.11v-.22s0,0-.01,0c-.01,0-.05-.03-.1-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m236.59,20.49l.13-.17s-.09-.08-.11-.14l-.2.07c.04.1.11.18.18.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m236.38,20.09c0,.06.01.12.03.17l.2-.08s-.02-.06-.02-.09c0-.24.19-.48.42-.68l-.15-.15c-.26.23-.48.52-.48.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m234.96,19.45s.05,0,.08.02l.07-.21s-.09-.03-.15-.03c-.27,0-.69.2-.94.51l.16.14c.16-.2.5-.42.78-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m235.11,19.26l-.08.2c.09.04.06.2.05.27l.22-.03c.03-.2-.02-.37-.19-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m235.09,19.73c-.03.13-.09.29-.17.43l.19.1c.1-.17.18-.38.2-.56l-.22.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m234.62,20.56c-.08.07-.19.12-.25.12-.01,0-.1-.04-.17-.1l-.14.16c.05.04.2.14.27.15.13.03.32-.06.43-.16.11-.1.24-.27.35-.46l-.19-.1c-.09.17-.2.32-.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m234.03,20.32l-.21.05c.03.12.1.25.25.37l.14-.17c-.11-.09-.16-.18-.17-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m234.02,20.26c0-.15.08-.29.17-.39l-.17-.13c-.13.15-.21.33-.21.52,0,.03,0,.07.01.11l.21-.05s0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m231.2,21.2l-.08.2c.16.05.21.15.23.25l.2-.08c-.05-.19-.18-.31-.35-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m231.35,21.64c.02.08.02.17,0,.28l.21.04c.03-.15.02-.29,0-.39l-.2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m231.31,22.07s-.21.07-.27.08c-.2.03-.3.11-.39.19-.1.09-.32.27-.44.17l-.15.16c.18.16.41.09.65-.09.14-.11.17-.18.35-.21.14-.02.39-.06.45-.22.02-.07.04-.13.05-.19l-.21-.04s-.02.1-.04.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m230.08,22.67l.14-.16c-.08-.07-.09-.21-.08-.3l-.21-.02c-.01.2.05.37.16.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m230.5,21.65l-.14-.16c-.05.04-.11.08-.15.12-.18.17-.27.39-.28.59h.22c0-.14.07-.31.21-.43.03-.03.09-.07.15-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m230.98,24.1l.07-.21c-.46-.03-1.22.05-1.59.6l.18.11c.3-.44.92-.52,1.34-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m231.5,24.17c.03.06.05.21,0,.33l.19.11c.13-.27.03-.6-.07-.64-.16-.05-.36-.08-.57-.09l-.06.21c.19,0,.37.03.52.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m231.5,24.5s0,.01,0,.02c-.02.05-.11.18-.39.17-.31,0-.51.09-.63.2l.15.16c.14-.12.31-.14.49-.14.34,0,.51-.14.59-.3l-.19-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m230.28,25.2c-.02.07-.08.15-.15.19l.13.18c.12-.07.2-.19.24-.31.03-.1.07-.17.14-.23l-.16-.15c-.11.1-.16.23-.19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m230.13,25.39s-.11.05-.3.05v.22c.26.01.39-.06.44-.09l-.13-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m229.77,25.43s-.09-.07-.11-.09l-.14.17s.1.08.11.09c.05.04.11.06.18.06v-.22s-.05-.01-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m229.57,25.25c-.04-.08-.06-.17-.06-.26h-.21c0,.13.03.26.09.37.02.04.08.09.14.14l.13-.17s-.07-.06-.08-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m229.64,24.6l-.18-.12c-.11.16-.16.34-.17.51h.21c0-.13.04-.26.13-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m232.72,25.93l.06-.21c-.83-.04-1.33.55-1.59.99l.17.13c.23-.4.7-.93,1.35-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m233.09,25.92c-.03-.13-.16-.19-.31-.21l-.07.21c.11,0,.16.04.17.04.02.08.03.15.02.24h.22c0-.11,0-.19-.02-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m232.9,26.21c-.02.18-.18.45-.19.45l.19.1s.2-.35.22-.57h-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m232.71,26.66c-.05.08-.23.3-.29.35l.1.19c.08-.04.32-.34.38-.44l-.19-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m232.42,27.01c-.18.09-.36-.02-.7.16-.19.1-.3.37-.39.42s-.19.08-.28.08c0,0,0,0,0,0v.22c.09,0,.27-.03.4-.12s.23-.33.38-.42c.27-.16.46-.03.7-.16l-.11-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m230.99,27.68l-.15.17s.12.05.2.05v-.22s-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m231.37,26.83l-.18-.12c-.1.15-.19.31-.27.45,0,0,0,0,0,.01l.2.08c.03-.05.2-.33.26-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m230.83,27.83s.02.01.03.02l.14-.17s0,0,0,0c0-.14.07-.34.13-.43l-.21-.07c-.07.13-.22.54-.08.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m229.65,29.65c.12-.03.19,0,.35.13l.12-.18c-.22-.16-.31-.19-.48-.17s-.35.13-.57.3l.13.17s.27-.21.44-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m230.12,29.59l-.13.17c.12.09.24.21.26.26,0,.01,0,.02,0,.03l.2-.08c-.04-.12-.19-.27-.34-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m230.46,29.97l-.2.09c.02.1.02.17-.01.22l.17.14c.11-.14.07-.4.04-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m230.25,30.28c-.03.06-.1.1-.21.14-.22.07-.39.25-.53.34-.09.06-.24.11-.33.1v.21c.15.02.34-.06.45-.14.15-.1.3-.26.48-.32.15-.05.25-.12.31-.21l-.17-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m229,30.77l-.12.18c.13.08.21.13.3.13v-.22s-.12-.05-.18-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m228.77,30.86s.07.06.12.09l.11-.19s-.06-.04-.08-.06c-.03-.03-.06-.12-.08-.21l-.21.04c.03.14.08.27.14.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m228.85,30.23c.05-.09.2-.22.36-.34l-.14-.16c-.17.13-.34.28-.41.4-.06.1-.06.26-.03.42l.21-.04c-.02-.1-.02-.22,0-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m235.98,26.38c.11-.14.33-.19.49-.19.08,0,.14.01.16.02.01.01.09.09.11.11l.16-.14c-.05-.05-.1-.1-.13-.13-.04-.04-.16-.07-.3-.07-.22,0-.49.07-.66.27-.1.12-.37.3-.39.31l.15.16s.28-.18.41-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m236.74,26.32c.12.12.28.3.28.45,0,.02,0,.04-.02.07l.2.09c.13-.28-.12-.58-.3-.76l-.16.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m237.21,26.92l-.2-.08s-.02.04-.04.06c-.03.01-.09.03-.15.04l.08.2c.1-.02.17-.04.21-.08.04-.05.08-.09.1-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m235.95,27.17l.09.2c.31-.22.71-.2.87-.23l-.09-.2c-.08.01-.57.02-.87.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m236.04,27.37l-.1-.19c-.27.17-.51.46-.73.59,0,0-.52.35-.64.32l.04.21c.21-.03.57-.26.72-.36.29-.19.46-.42.71-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m234.42,28.04l-.11.18c.08.06.21.1.32.09l-.05-.21c-.05,0-.11-.02-.15-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m234.32,28.22l.11-.18c-.12-.08-.28-.39-.01-.85l-.16-.14c-.38.62-.13,1.05.07,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m234.59,27.03c.42-.06.65-.09.98-.32l-.14-.17c-.3.22-.47.21-.87.27-.14.02-.25.12-.32.24l.17.13c.05-.08.11-.15.19-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m232.17,31.43l.06-.21c-.34-.09-.89.1-1.13.27l.14.16c.2-.14.72-.3.94-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m232.22,31.22l-.07.21c.06.01.2.05.21.25l.21-.05c-.02-.19-.14-.34-.36-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m232.37,31.68c0,.09-.02.18-.05.24l.18.12c.09-.15.1-.3.08-.42l-.21.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m231.09,32.17l-.12.18c.23.15,1.17.27,1.53-.33l-.18-.11c-.26.46-1.06.36-1.23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m230.81,31.98c-.02.19.05.31.17.38l.11-.19s-.03-.03-.05-.04c-.02-.03-.03-.08-.02-.14l-.21-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m231.04,31.92c.02-.08.05-.18.19-.27l-.13-.17c-.16.12-.22.24-.26.38-.01.04-.02.09-.02.12h.22s0-.04.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m225.35,31.79c.08-.07.98-.36,1.05-.37.04,0,.1-.01.14.01l.09-.2c-.09-.04-.21-.03-.23-.03-.11,0-1.04.3-1.18.42-.06.05-.1.14-.12.25l.2.09c0-.08.03-.15.05-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m226.62,31.24l-.1.19c.06.02.11.1.14.32,0,.06-.03.16-.09.25l.18.11c.09-.14.13-.27.12-.39-.03-.31-.14-.44-.26-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m226.77,32.11l-.19-.1c-.09.15-.2.24-.3.31l.11.19c.16-.12.3-.26.38-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m225.69,32.64v.22c.27-.07.64-.3.71-.36l-.12-.18c-.18.14-.5.29-.59.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m225.69,32.64c-.07.02-.14.04-.2.04v.22c.06,0,.15-.02.22-.04l-.02-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.36,32.64l-.14.17c.08.07.17.1.26.1v-.22c-.07,0-.1-.02-.12-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m225.08,32.34c.02.2.07.38.12.44.01.01.03.02.04.04l.13-.17c-.04-.06-.06-.19-.07-.34l-.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m225.29,31.95l-.2-.08c-.03.14-.03.32-.01.47l.21-.05c0-.12,0-.25,0-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m230.15,33.66l.11-.19c-.12-.07-.23-.17-.35-.29-.03-.03-.08-.05-.15-.05-.16,0-.41.1-.55.34l.18.12c.1-.18.28-.25.37-.25.12.14.25.24.38.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m230.81,33.76c-.06-.03-.53-.27-.56-.29l-.1.19s.55.28.57.29c.03.01.04.03.05.06l.22.03c0-.12-.06-.22-.17-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m230.76,34.01s0,.13-.08.22l.16.14c.09-.11.13-.23.13-.34l-.22-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m230.69,34.22c-.15.17-.63.13-.69.12v.22s.66.07.86-.21l-.17-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m229.56,34.24l-.09.19c.13.06.3.11.53.13v-.22c-.21-.02-.34-.07-.43-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m229.29,34.32c.05.05.12.09.19.12l.08-.2s-.08-.04-.11-.07l-.16.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m229.36,34.06l-.18.11c.03.05.07.11.12.15l.15-.15s-.07-.07-.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m229.33,33.87h-.21c0,.12.02.23.07.31l.18-.12c-.03-.07-.04-.13-.03-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m229.39,33.59l-.18-.13c-.09.14-.11.33-.1.42l.21-.02c0-.09.02-.2.07-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m234.41,32.79c-.11-.06-.21-.16-.33-.16-.01,0-.27,0-.41.31l.19.11c.04-.1.11-.19.22-.21.04,0,.17.1.23.13.11.06.21.09.34.08l.04-.22c-.12.01-.2-.01-.28-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m234.92,32.83c-.07,0-.17.02-.24.02l-.03.22c.07,0,.22-.03.27-.03.13,0,.22.05.3.32.02.07.02.14.01.2l.2.09c.02-.1.03-.23,0-.35-.07-.23-.19-.47-.5-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m235.43,33.64l-.2-.08s-.01.07-.02.09l.12.19c.07-.04.09-.11.11-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m235.21,33.65c-.1,0-.16-.03-.3-.04-.25,0-.64.14-.68.15l.04.21c.22-.06.45-.15.66-.14.13,0,.3.08.42,0l-.13-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m233.98,33.73l-.12.18c.18.12.37.08.41.06l-.05-.21s-.14.04-.24-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m233.87,33.61l-.18.12c.05.08.11.14.17.18l.11-.18s-.09-.08-.11-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m233.81,33.46l-.2.07c.02.07.05.15.09.21l.18-.12s-.05-.1-.06-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m233.86,33.06l-.18-.12c-.13.3-.09.51-.07.6l.2-.08c-.01-.06-.03-.21.05-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m233.73,22.58c.27-.12.48-.29.76-.28.16,0,.35.06.42.07l.07-.2c-.09-.02-.3-.08-.49-.08-.27,0-.46.11-.81.28-.19.09-.27.2-.3.24l.18.13c.03-.05.1-.11.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m234.97,22.16l-.06.21c.12.03.34.08.41.12l.17-.14c-.04-.07-.33-.14-.52-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m235.48,22.33l-.16.15c.03.07.02.15-.01.23l.2.09c.08-.18.06-.37-.03-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m235.31,22.71c-.03.07-.08.15-.2.2-.15.06-.86.56-1.02.64l.09.2c.14-.07.91-.6,1.02-.64.16-.07.26-.19.31-.32l-.2-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m233.97,23.6l.02.22s.12-.03.19-.07l-.1-.19s-.07.03-.11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m233.54,23.61l-.02.21c.12.03.35.02.49,0l-.03-.21c-.12.03-.34.03-.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m233.44,23.54l-.14.17c.08.07.15.1.22.11l.02-.22s-.07-.04-.1-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m233.3,23.32l-.21.03c.02.14.12.28.22.37l.13-.17c-.06-.06-.13-.14-.14-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m233.31,23.25c.03-.11.14-.38.25-.53l-.17-.13c-.15.2-.27.51-.29.61-.01.06-.01.11,0,.16l.21-.04s0-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m252.22,20.42c-.39.03-.65-.23-.97-.22-.05,0-.26.09-.46.18l.14.17c.15-.07.29-.13.35-.14.18-.01.54.26.95.22.07,0,.25.04.47.13l.11-.19c-.14-.07-.48-.16-.58-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m253.37,21.02c-.07-.19-.32-.35-.58-.45l-.1.19c.22.09.43.21.48.33.03.08.01.19-.03.28l.19.1c.06-.14.09-.31.04-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m253.14,21.38c-.05.12-.12.22-.17.25-.09.01-.3-.04-.34-.06-.23-.12-.99-.47-1.27-.43v.22c.21-.04.94.27,1.17.4.05.03.39.13.53.07.08-.04.2-.19.27-.36l-.2-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m251.37,21.14c-.17,0-.45.17-.58.18v.22c.17,0,.45-.17.6-.18v-.22h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250.79,21.32s-.11-.04-.19-.09l-.14.17c.11.08.24.14.33.14v-.22s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m250.47,21.41l.13-.17c-.08-.05-.21-.14-.2-.21l-.21.03c.01.18.19.28.29.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m250.51,20.76c.07-.04.24-.12.41-.2l-.13-.18c-.17.07-.33.15-.39.19-.12.07-.24.29-.22.49l.21-.04c0-.13.09-.25.12-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m255.14,21.6c-.17.03-.4.26-.52.39-.2.23-.55.54-.65.84-.07.22-.16.48-.18.69h.21c0-.09.14-.57.21-.71.11-.22.39-.47.57-.67s.34-.32.39-.32c.1-.01.32.07.5.16l.14-.17c-.21-.11-.51-.23-.67-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m256.16,22.01c-.08-.06-.21-.14-.36-.22l-.13.18c.14.07.28.15.35.21.02.02.06.05.02.16l.2.09c.06-.16.05-.31-.08-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m256.05,22.34c-.05.15-.2.3-.25.32l.05.21c.12-.03.33-.24.4-.45l-.2-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m255.65,22.91c.06-.01.18-.04.2-.05l-.06-.21h0s-.15.04-.19.05-.14.02-.24.07l.09.2c.07-.04.13-.04.2-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m255.08,23.03c-.12.14-.45.63-.65.76-.07.05-.25.03-.27.02l-.12.18c.16.09.44.02.48,0,.34-.25.47-.51.73-.82.06-.08.13-.15.21-.2l-.1-.19c-.11.06-.2.16-.28.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m254.05,24l.11-.19c-.11-.05-.16-.14-.15-.28l-.21-.02c-.01.2.05.38.26.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m258.05,21.25c-.06-.28.11-.51.36-.53.01,0,.39-.02.8.12.17.06.62.45.7.51.08.06.27.15.29.16l.15-.17c-.1-.05-.22-.11-.31-.17-.24-.18-.47-.4-.74-.53-.21-.1-.73-.16-.92-.14-.61.08-.64.82-.45.94l.15-.19s-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m260.66,22.33c.04.12.11.33.12.51l.22.02c0-.26-.12-.55-.15-.68-.07-.22-.13-.51-.3-.7-.05-.06-.13-.11-.21-.15l-.14.17c.08.04.15.08.19.12.14.16.18.41.28.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m260.78,22.84c0,.1-.01.2-.06.26l.11.19c.12-.1.17-.28.17-.44l-.22-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m260.4,23.07l-.04.21c.11.03.41.07.49,0l-.12-.18c-.08,0-.22,0-.32-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m259.9,22.8l-.15.15c.15.18.4.28.62.33l.03-.21c-.2-.05-.4-.14-.5-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m259.85,22.73c-.09-.24-.37-.58-.48-.77-.15-.26-.27-.37-.32-.4l-.14.16c.08.06.19.2.34.46.07.13.3.39.41.64.02.05.05.1.09.14l.15-.16s-.03-.04-.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.07,21.25l-.16.19s.04.02.06.03c.3,0,.71.06.94.26l.13-.17c-.28-.23-.7-.29-.98-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m258.4,23.78c-.01-.12.02-.19,0-.29-.03-.14-.12-.2-.24-.22-.16-.02-.89.1-1.15.18-.19.06-.34.15-.48.28l.18.12c.11-.09.22-.15.36-.2.2-.07,1.03-.22,1.1-.16.02.01.03.05.02.13-.01.16,0,.43.17.59l.18-.13s-.1-.07-.13-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m258.53,24.08l-.17.14s.33.27.44.36l.14-.16c-.13-.12-.3-.25-.41-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m258.93,24.41l-.13.17c.07.06.12.11.16.15,0,.02-.01.07-.04.12l.19.11c.08-.15.1-.29.03-.37-.05-.05-.12-.11-.19-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m259.1,24.95l-.19-.1c-.08.14-.2.26-.28.29l.05.21c.16-.05.33-.22.42-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.63,25.14s-.02,0-.03,0c-.19,0-.71-.17-.79-.23l-.06.21c.19.09.78.28.94.22l-.06-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m257.81,24.91c-.08-.05-.13-.12-.2-.19-.06-.07-.16-.18-.24-.23l-.11.18c.13.09.25.29.43.42.01.01.04.02.07.04l.05-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m257.11,24.43c-.16,0-.47.05-.51.04-.11-.03-.18-.08-.22-.12l-.2.08c.06.12.21.2.36.25.1.03.42-.04.57-.04.07,0,.12,0,.16.03l.1-.19c-.09-.05-.19-.06-.26-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m256.36,24.32s0-.02.02-.07c.11-.17.21-.3.32-.39l-.17-.13c-.11.11-.22.24-.32.41-.08.12-.07.22-.02.31l.2-.09s-.02-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m261.05,25.65c.08-.11.19-.36.31-.37s.23.2.41.6l.21-.07c-.09-.18-.29-.74-.62-.74-.25,0-.37.29-.47.44-.06.1-.3.24-.39.47l.21.06c.06-.14.28-.31.34-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m261.97,25.79l-.2.08c.06.13.13.27.15.34l.21-.06c-.03-.09-.09-.23-.16-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m262.13,26.14l-.2.07s.01.11,0,.17l.2.08c.03-.11.04-.23,0-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m262.12,26.46l-.2-.07s-.03.1-.06.14l.16.14c.04-.06.08-.14.1-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m261.6,26.63c-.28,0-.62-.12-.8-.21l-.13.17c.23.14.63.26.93.26.1,0,.18-.01.25-.04l-.08-.2s-.07.02-.17.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m260.7,26.35l-.19.09c.03.05.09.11.17.15l.13-.17s-.08-.05-.1-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m260.71,26.04l-.2-.07c-.08.17-.05.38,0,.49l.19-.1c-.04-.13-.03-.22.01-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m263.72,27.6c-.31.01-.83.03-.95.02-.22-.02-.35.05-.44.14l.16.15c.05-.05.12-.08.25-.07.19.02.58-.01.99-.02.18,0,.6.05.8.12l.07-.2c-.27-.08-.68-.14-.88-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m264.6,27.73l-.08.2c.14.04.25.1.25.17,0,.07,0,.2-.02.34l.21.07c.02-.18.03-.35.02-.42-.01-.19-.18-.3-.39-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m264.76,28.45c-.02.18-.05.38-.09.44l.14.16c.09-.07.13-.32.16-.54l-.21-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.82,29.04l-.15-.15c-.09.09-.31.15-.42.14l.02.22c.21,0,.42-.08.55-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m264.11,28.98c-.1-.09-.2-.16-.3-.21l-.09.2c.07.03.16.09.23.16.08.07.19.11.31.11l-.03-.22c-.06,0-.11-.02-.13-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m263.11,28.66s-.2,0-.27,0c-.1,0-.17-.02-.23-.05l-.15.17c.09.05.22.09.37.1.07,0,.26,0,.28,0,.22,0,.43,0,.63.1l.08-.2c-.24-.11-.49-.11-.71-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m262.46,28.48l-.19.11c.05.07.12.14.2.18l.14-.17c-.07-.03-.11-.07-.15-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m262.51,27.9l-.17-.14c-.2.2-.25.58-.07.84l.18-.12c-.08-.1-.16-.39.05-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m261.4,29.76c-.19,0-.46.23-.5.4-.01.05,0,.18.02.32h.22c-.02-.12-.03-.23-.03-.28.02-.07.18-.21.28-.23.07.03.18.14.28.25l.17-.13c-.15-.18-.34-.34-.45-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m261.84,30.09l-.17.14c.09.11.16.22.18.28l.21-.05c-.02-.09-.11-.24-.22-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m262.06,30.44l-.21.06s0,.14,0,.16l.21.03c0-.06,0-.2,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m261.81,30.79c-.08.03-.33.04-.47.03l-.1.21c.25.03.59.01.69-.05.12-.08.15-.18.15-.29l-.22-.02c0,.08-.01.1-.05.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m261.22,30.8l-.14.18s.09.03.15.04l.09-.21s-.08,0-.11-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m261.22,30.8c-.03-.07-.06-.2-.08-.33h-.22c.03.22.1.48.17.52l.13-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m265.63,32.85l.11.19c.21-.08.6-.16.73-.03l.16-.15c-.24-.24-.79-.1-1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m266.62,32.85l-.15.16c.11.09.19.24.21.41l.22.05c0-.23-.12-.48-.28-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m266.89,33.62c0-.05.01-.11.01-.16l-.22-.04s0,.08,0,.12c0,0,0,0-.01,0l.16.15s.05-.05.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m266.67,33.56c-.05.03-.14.06-.24.1l.02.22c.17-.05.32-.11.39-.17l-.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m265.85,33.76s-.05-.01-.08-.03l-.13.18c.05.03.11.05.16.06.11.02.43-.04.65-.1l-.03-.21c-.21.07-.53.12-.58.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m265.31,33.3c0,.09,0,.18.03.27l.21-.06c-.02-.08-.03-.15-.02-.21h-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m265.74,33.04l-.1-.19c-.3.13-.32.33-.33.45h.22c0-.08,0-.18.21-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m262.67,32.45c-.21,0-.39.24-.57.37-.1.08-.2.11-.29.11-.19,0-.62-.21-.81-.2-.14,0-.29.11-.38.19l.17.13c.1-.08.16-.11.22-.11.22.02.48.18.77.2.44.03.7-.48.88-.48.04,0,.17.04.28.11l.1-.19c-.14-.08-.29-.14-.38-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m263.33,32.97c0-.16-.13-.29-.29-.38l-.09.2s.08.06.12.09c.04.04.05.07.05.09s0,.11,0,.18h.22c0-.05,0-.14,0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m263.3,33.38c.03-.07.04-.15.03-.23h-.22c0,.06,0,.12,0,.14,0,0-.02.01-.03.02l.14.16s.06-.06.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m263.09,33.31c-.15.09-.28.1-.38.18-.18.13-.28.33-.36.41l.12.19c.16-.15.23-.32.37-.43.06-.05.28-.1.4-.19l-.15-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m260.71,33.73l-.13.18c.58.29,1.15.39,1.63.3l-.05-.21c-.38.08-.93-.01-1.45-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m262.34,33.9s-.08.07-.19.1l.04.21c.12-.03.21-.07.27-.13l-.13-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m260.51,33.59l-.2.07c.04.09.15.18.28.25l.12-.18c-.14-.07-.18-.12-.19-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m260.79,33.05l-.17-.14c-.23.2-.4.58-.31.76l.2-.08c-.04-.12.09-.38.28-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m257.7,29.14c-.35.01-.9.17-1.07.44l.2.09c.14-.18.59-.31.9-.32.06,0,.26.01.63.15l.08-.2c-.36-.14-.59-.18-.74-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m258.66,29.43c-.07-.04-.15-.08-.24-.11l-.08.2c.07.03.14.06.2.1.11.06.32.31.36.5l.21-.03c-.05-.28-.33-.57-.47-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m258.91,30.11c.02.08.03.16.02.24l.21.06c.02-.1.02-.23-.01-.35l-.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m259.14,30.4l-.21-.05s0,.02,0,.03c-.02.09-.05.14-.07.15,0,0-.01,0-.02,0l.11.19c.1-.05.17-.17.2-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.83,30.53s-.03,0-.06,0c-.13,0-.3-.04-.38-.08-.06-.03-.27-.16-.3-.18l-.09.2c.1.06.2.13.3.18.11.05.31.1.47.1.05,0,.13,0,.17-.03l-.12-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m257.88,30.17s-.04-.01-.06-.02l-.07.2s.04.01.05.02c.07.03.14.07.21.11l.09-.2c-.07-.04-.14-.08-.22-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m257.25,30.06c-.1,0-.22-.02-.32-.03l-.08.2c.14.02.31.04.39.04.17,0,.35.02.52.08l.07-.21c-.2-.06-.4-.08-.57-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m256.73,29.97l-.19.1c.08.13.22.14.32.16l.07-.21c-.07-.01-.16-.02-.2-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m256.72,29.96c-.02-.06.05-.21.11-.28l-.19-.1c-.06.09-.2.34-.1.51l.19-.11s0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m257.03,32.65c-.23.07-.59.12-.82.17-.14.03-.24.13-.29.22l.2.08s.07-.08.13-.1c.24-.05.58-.1.84-.17.23-.07.48-.19.68-.19.16,0,.29.03.42.1l.14-.16c-.18-.12-.38-.15-.57-.16-.23,0-.54.14-.74.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m258.55,32.98c0-.16-.09-.29-.22-.37l-.14.17c.13.07.14.15.14.2,0,.11-.02.23-.04.34l.21.02c.02-.14.04-.28.04-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m258.3,33.32c-.04.21-.1.4-.15.51l.16.14c.11-.17.17-.43.21-.64h-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m258.05,33.93l.06.2c.08-.02.14-.09.2-.18l-.17-.14c-.03.06-.06.1-.09.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m257.99,33.94s-.09-.01-.13-.03l-.09.19c.07.03.15.05.22.05.03,0,.1,0,.13-.02l-.07-.2s-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m257.54,33.63c-.13-.16-.35-.21-.55-.23v.22c.17.01.31.06.39.15.12.14.25.27.4.34l.09-.2c-.1-.04-.2-.13-.32-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m256.46,33.4l-.04.22c.11,0,.41-.02.57,0v-.22c-.16-.02-.51,0-.53,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m256.32,33.41s-.05,0-.07,0l-.03.21s.07,0,.1,0c.04,0,.07,0,.11,0l.03-.22c-.05,0-.1,0-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m256.15,33.35l-.14.17c.07.06.15.1.21.11l.02-.21s-.06-.03-.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m256.07,33.26s.02-.08.06-.13l-.2-.09c-.06.1-.08.2-.07.25,0,.07.08.16.17.23l.13-.17s-.07-.06-.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m252.56,32.2s-.08.12-.1.22l.21.04s.03-.09.05-.11c.06-.06.5-.26,1.18.05l.08-.2c-.75-.33-1.28-.13-1.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m253.96,32.2l-.07.21c.06.03.1.06.13.09.05.05.06.15.02.28l.21.05c.05-.17.04-.36-.08-.48-.06-.05-.13-.1-.22-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m253.96,32.94c-.24.1-.68.06-.82,0l-.06.21c.16.07.76.13,1.01-.04.08-.05.14-.17.18-.3l-.21-.04c-.03.09-.06.16-.09.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m252.71,32.7l-.19.1c.11.17.44.31.57.35l.06-.21c-.13-.05-.37-.16-.44-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m252.69,32.68c-.04-.07-.04-.15-.03-.22l-.21-.05c-.03.12-.02.26.05.38,0,0,0,.01.01.02l.19-.11s0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m251.56,27.58c-.22,0-1.67.86-2.58,1.75l.17.13c1.01-.96,2.24-1.62,2.4-1.66.29.07,1.19.37,2.06.39l.07-.21c-.59,0-1.24-.15-2.12-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m253.67,27.98l-.06.21c.17,0,.41.02.5.31l.21-.06c-.08-.25-.27-.45-.65-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m254.12,28.5c.05.16.04.34,0,.48l.21.07c.05-.18.06-.42,0-.62l-.2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m254.12,28.98c-.02.09-.05.16-.08.19-.1.13-.24.18-.48.18-.36,0-.88-.15-1.32-.15-.14,0-.35.02-.46.08l.1.19c.07-.04.26-.06.37-.06.42,0,.91.15,1.32.15.26,0,.49-.06.65-.27.05-.06.09-.16.12-.27l-.21-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m250.83,30.52s-.04.02-.06.04l.17.15s.03-.02.04-.02c.11-.08.63-1.05.92-1.2l-.11-.19c-.34.18-.8,1.05-.95,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m249.58,24.76s-.05-.01-.09-.01c-.22,0-.79.07-1.26.14-.4.06-.73.11-.73.11l.18.19c.16-.02.37-.06.59-.09.48-.07,1.01-.14,1.21-.14,0,0,.01,0,.02,0h0s0,0,0,0l.07-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m249.57,24.76l-.07.21c.09.07.31.3.49.54l.17-.14c-.23-.29-.5-.58-.59-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m250.35,26.01s.01.12.01.15l.21.06c0-.08,0-.16-.01-.25,0-.08-.19-.35-.4-.61l-.16.15c.16.21.31.41.35.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m250.57,26.21l-.21-.06c0,.07-.02.1-.11.16-.91.64-1.59,1.12-2.13,1.63-.37.35-.65.6-.83.75,0,0,0-.03,0-.03l-.17.4c.13,0,.71-.54,1.15-.96.65-.63,1.63-1.27,2.1-1.61.14-.1.18-.19.19-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m247.25,26.9c-.12,1.02-.23,2.09-.15,2.16,0,0,.01,0,.02,0,0,0,.17-.38.17-.38.02-.39.1-1.11.2-1.93l-.24.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m247.7,25.2s0,0,0,0l-.19-.19s-.13.93-.25,1.9l.24-.16c.06-.5.13-1.03.21-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m244.77,24.22c-.43,0-.85.09-.97.23l.18.12c.09-.06.36-.14.78-.14.15,0,.37.01.49.05l.09-.2c-.11-.04-.43-.06-.59-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m245.35,24.28l-.08.2c.15.04.26.15.33.22l.22-.07s-.16-.26-.46-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m245.58,24.69c-.07.6-.18,1.37-.28,2.05l.2.11c.16-1.04.3-2.22.3-2.22l-.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m245.3,26.74c-.11.78-.23,1.43-.29,1.57l.19.1c.08-.16.19-.84.3-1.57l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m244.84,28.44v.22c.15,0,.31-.12.37-.25l-.2-.09c-.03.07-.11.12-.18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m244.79,28.42c-.09-.06-.18-.13-.29-.2l-.11.19c.1.06.2.13.27.18.06.04.12.06.18.06v-.22s-.03,0-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m241.65,26.76s-.03-.02-.04-.02l-.16.16s.07.05.11.06c.7.32,2.06.98,2.83,1.47l.1-.19c-.8-.5-2.16-1.16-2.84-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m241.39,26.24s.03-.09.06-.13l-.16-.14c-.22.26-.14.71.17.93l.15-.16c-.18-.11-.26-.33-.22-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m242.6,25.86c-.42,0-.72-.08-.87-.08-.2,0-.35.08-.44.19l.17.13c.05-.06.13-.1.27-.11.15,0,.39.08.87.08.31,0,.53-.04.66-.13l-.11-.19c-.1.07-.3.1-.56.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m243.14,25.77l.12.18c.22-.14.55-.78.73-1.38l-.19-.12c-.18.64-.51,1.22-.66,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m240.76,28.31c-.17-.08-.49-.22-.75-.22-.07,0-.14,0-.19.04l.08.2s.04-.03.12-.03c.18,0,.46.1.65.19.25.12,1.02.57,1.54.91l.13-.17c-.59-.39-1.46-.87-1.58-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m242.33,29.23l-.12.18c.25.16.44.31.49.38.06.09.07.25.01.4l.19.11c.09-.2.09-.46-.02-.63-.07-.1-.28-.26-.54-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m242.71,30.19s-.09.23-.24.23c-.1,0-.43-.06-1.08-.23-.11-.03-.35-.07-.7,0v.22c.36-.07.56-.03.65,0,.08.02.91.24,1.14.24.2,0,.35-.15.43-.34l-.19-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m239.42,30.71l.03.22c.34-.15.72-.44,1.22-.53v-.22c-.6.11-.9.36-1.26.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m238.43,31.06l.03.21c.27-.05.63-.17,1.01-.35l-.04-.22c-.4.19-.75.31-.99.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m238.43,31.06c-.2.04-.27.01-.28.01l-.08.2s.16.04.39,0l-.04-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m236.55,30.19l-.18.12c.24.41.81.65,1.28.82l.07-.21c-.51-.19-.99-.41-1.17-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m236.53,29.68l-.19-.11c-.14.32-.08.57.03.75l.18-.13c-.07-.14-.1-.31-.02-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m238.73,29.19c-.31,0-.73-.09-1.12-.31-.11-.06-.22-.09-.32-.09-.42,0-.8.41-.95.78l.19.1c.12-.32.45-.66.76-.66.07,0,.15.02.22.06.38.22.83.34,1.23.34.16,0,.36-.02.51-.11l-.1-.19c-.08.06-.22.09-.4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m239.12,29.11l.11.18c.28-.17.54-.85.66-.97l-.07-.21c-.23.08-.41.78-.7.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m230.1,42.7c-.26,0-.52.1-.73.3-.45.4-.45.94-.31,1.37.07.23.18.58.2.67.07.28.05.53-.17.73-.11.1-.23.14-.34.14-.19,0-.37-.11-.5-.27-.27-.3-.3-.66-.12-1.11l-.67-.25c-.3.71-.13,1.33.3,1.81.34.38.73.57,1.12.57.29,0,.56-.11.8-.32.47-.42.47-.98.38-1.31-.04-.14-.21-.64-.26-.87-.07-.28-.05-.48.12-.63.09-.08.19-.12.29-.12.12,0,.24.06.35.18.17.19.18.4.07.67l.66.26c.22-.59.08-1.02-.24-1.37-.28-.32-.61-.46-.92-.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m232.98,45.12l-2.69,3.35.64.51,2.69-3.35-.38-.3-.26-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m234.82,46.56l-2.03,3.79.63.34,1.43-2.66.14,3.51.67.36,2.03-3.79-.62-.33-1.43,2.67-.15-3.52-.67-.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m240.21,48.94c-.84,0-1.63.52-1.93,1.72-.37,1.45.37,2.36,1.38,2.61.17.04.35.07.51.07.5,0,.97-.2,1.31-.67l-.57-.47c-.2.24-.48.43-.83.43-.08,0-.17-.01-.26-.03-.59-.15-.97-.73-.72-1.73.21-.82.67-1.21,1.19-1.21.09,0,.18.01.27.03.39.1.6.35.71.68l.74-.19c-.17-.63-.67-1.01-1.27-1.17-.18-.04-.35-.07-.53-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m243.46,49.56l-.13,4.3,2.78.08.02-.68-1.96-.06.04-1.28,1.42.04.02-.68-1.42-.04.03-.99,1.89.06.02-.68-2.71-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m251.11,48.74l-.4.11-1.11,1.04.4.53.6-.45.85,3.14.79-.21-1.12-4.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m254.03,47.64c-.21,0-.43.05-.66.15-.75.35-.98,1.05-.73,1.59.15.32.46.57.96.59-.4.37-.46.88-.26,1.31.2.43.62.69,1.13.69.24,0,.5-.06.76-.18.81-.38,1.13-1.13.83-1.77-.18-.38-.55-.66-1.01-.66-.05,0-.1,0-.15,0,.31-.39.32-.79.17-1.11-.17-.38-.56-.63-1.03-.63h0Zm-.21,1.81c-.21,0-.38-.12-.47-.32-.13-.27-.05-.59.3-.75.1-.05.19-.07.28-.07.22,0,.4.13.49.33.13.27.05.57-.3.74-.1.05-.2.07-.29.07h0Zm.74,1.81c-.25,0-.46-.13-.57-.37-.16-.34-.04-.74.39-.94.13-.06.25-.08.36-.08.27,0,.5.15.61.39.16.35.01.72-.4.91-.13.06-.26.09-.38.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m257.43,45.66c-.31,0-.65.11-.95.33-.77.55-.74,1.32-.33,1.96l.62-.44c-.23-.39-.19-.72.12-.95.13-.09.26-.13.38-.13.21,0,.39.13.51.29.18.25.18.53.13,1.03l-.25,2.3.22.3,2.36-1.7-.39-.55-1.34.96.19-1.58c.06-.49.03-.91-.25-1.3-.26-.36-.62-.53-1.01-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m260.64,42.84c-.48,0-.89.2-1.19.53-.61.66-.67,1.77.43,2.78.56.52,1.12.73,1.61.73s.89-.2,1.19-.53c.61-.66.67-1.77-.43-2.78-.56-.52-1.12-.73-1.61-.73h0Zm.98,3.27c-.32,0-.72-.18-1.17-.59-.75-.7-.83-1.31-.49-1.68.14-.15.32-.23.55-.23.32,0,.72.18,1.17.59.75.7.83,1.31.49,1.68-.14.15-.32.23-.55.23h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m2.42,23.26c0,5.63,3.75,7.72,9.39,9.13,5.37,1.28,6.47,2.96,6.47,5.07,0,2.34-2.1,3.98-5.11,3.98-3.25,0-6.01-1.17-8.95-3.79-.1.12-2.81,3.46-2.9,3.58,3.3,3.03,7.36,4.64,11.73,4.64,6.02,0,10.06-3.58,10.06-8.91,0-4.67-2.8-7.46-9.07-9.04-5.68-1.41-6.79-2.94-6.79-5.12,0-1.9,1.62-3.82,4.7-3.82,2.55,0,5.06.98,7.69,3,.09-.12,2.51-3.66,2.59-3.78-2.96-2.45-6.3-3.64-10.19-3.64-5.57,0-9.62,3.66-9.62,8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m39.16,23.31c-.03.11-4.81,15.51-4.81,15.51,0,0-4.32-15.31-4.36-15.43h-4.86c.06.2,6.85,22.1,6.89,22.22h4.26c.04-.11,4.89-15.37,4.89-15.37,0,0,4.81,15.26,4.84,15.37h4.26c.03-.11,6.9-22.01,6.97-22.22h-4.74c-.03.11-4.44,15.42-4.44,15.42,0,0-4.81-15.4-4.85-15.51h-4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.57,34.42v.08c0,6.63,4.59,11.44,10.91,11.44,4.02,0,6.25-1.18,8.01-2.3-.04-.11-1.24-3.7-1.3-3.88-2,1.39-3.99,1.99-6.63,1.99-3.41,0-5.74-2.06-6.24-5.52v-.09s15.6,0,15.74,0c0-.01,0-.03,0-.03l.07-1.32c0-5.91-3.15-11.86-10.18-11.86-5.92,0-10.39,4.94-10.39,11.49Zm4.71-1.57c.46-3.6,2.68-5.92,5.64-5.92s5.15,2.27,5.51,5.92v.09s-11.16,0-11.16,0v-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m101.14,14.55v10.72l-.13-.1c-2.02-1.59-3.92-2.24-6.54-2.24-4.9,0-9.86,3.93-9.86,11.44v.08c0,7.51,5.23,11.45,10.39,11.45,4.63,0,10.26-.9,10.89-1V14.55h-4.75Zm-11.74,19.91v-.08c0-4.17,2.63-7.19,6.25-7.19,3.36,0,5.58,2.24,5.58,3.15v10.93h-.07s-1.94.38-5.51.38-6.25-3.09-6.25-7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m112.21,14.55v30.35c.63.1,6.26,1,10.89,1,5.16,0,10.39-3.93,10.39-11.45v-.08c0-7.51-4.96-11.44-9.86-11.44-2.62,0-4.52.65-6.54,2.24l-.13.1v-10.72h-4.75Zm4.73,26.73h-.06v-10.94c0-.91,2.22-3.15,5.58-3.15,3.62,0,6.25,3.02,6.25,7.19v.08c0,4.1-2.69,7.19-6.25,7.19s-5.49-.36-5.51-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m139.33,24.87c.04.13,1.24,3.78,1.29,3.93,1.91-.82,3.68-1.36,6.08-1.36,3.45,0,5.35,1.72,5.35,4.83v.53l-.11-.04c-1.68-.55-3.32-.92-5.9-.92-5.39,0-8.6,2.69-8.6,7.2v.08c0,4.65,3.91,6.77,7.55,6.77,5.25,0,11.09-.9,11.72-1v-12.55c0-6.08-3.23-9.3-9.33-9.3-3.42,0-5.7.72-8.06,1.81Zm2.82,14v-.08c0-2.21,1.86-3.53,4.99-3.53,1.73,0,3.53.32,4.94.89l.05.02v5.65h-.07s-2.17.42-5.69.42c-2.52,0-4.22-1.35-4.22-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m162.72,23.93v21.51h4.75v-17.89h.07s2.03-.36,4.84-.36,4.66,2.14,4.66,5.71v12.54h4.75v-14.05c0-5.22-2.89-8.46-7.55-8.46-5.29,0-10.89.9-11.52,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m187.87,14.55v30.89h4.75v-6.3l3.09-3.33s6.43,9.57,6.48,9.64h5.49c-.16-.24-8.75-13.09-8.75-13.09,0,0,8.19-8.69,8.44-8.95h-5.74c-.05.05-9,9.97-9,9.97V14.55h-4.75Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 274.72,
    y: 59.74,
    width: 1.28,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 0.03,
    y: -0.31,
    width: 1.28,
    height: 1.28
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwedbankLogo);
export default __webpack_public_path__ + "static/media/swedbank-logo.5338e623ff86301cfe616a6b7275dbd8.svg";
export { ForwardRef as ReactComponent };